var _path, _g, _path2, _rect, _rect2, _g2, _g3, _g4, _rect3, _g5, _g6, _g7, _path3, _rect4, _rect5, _g8, _g9, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect6, _rect7, _rect8, _rect9, _g10, _g11, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcosystem1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 600 591",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "m299.71 358.37c37.627 0 68.129-30.503 68.129-68.13s-30.502-68.13-68.129-68.13-68.13 30.503-68.13 68.13 30.503 68.13 68.13 68.13z",
    stroke: "#0FF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "logoFirst"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m291.42 268.56c-8.643-2.474-18.428 5.228-21.856 17.204-3.428 11.975 0.799 23.689 9.442 26.164 8.643 2.474 18.429-5.229 21.857-17.204 3.428-11.976-0.8-23.689-9.443-26.164zm-1.456 11.25a4.503 4.503 0 1 1-8.976-0.744 4.503 4.503 0 0 1 8.976 0.744zm32.668-1.894c-6.748-1.932-14.389 4.082-17.066 13.432-2.676 9.351 0.625 18.497 7.373 20.429s14.389-4.082 17.066-13.432c2.677-9.351-0.624-18.497-7.373-20.429zm-0.994 10.825a4.503 4.503 0 1 1-8.977-0.743 4.503 4.503 0 0 1 8.977 0.743z",
    fill: "#4AFC38"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "lineWithLogo"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "m299.71 426.5c75.254 0 136.26-61.005 136.26-136.26s-61.006-136.26-136.26-136.26c-75.253 0-136.26 61.006-136.26 136.26s61.006 136.26 136.26 136.26z",
    stroke: "#0FF",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 302.22,
    y: 396.8,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#az)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 408.05,
    y: 292.14,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#ay)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "logoThatMoves",
    clipPath: "url(#ax)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aw",
    className: "d",
    x: 373,
    y: 176,
    width: 54,
    height: 54,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "clip0_12006"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m426.86 176.9h-52.917v52.917h52.917v-52.917z",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "Group",
    mask: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m421.883 217.74-18.861 9.127-2.124-.693v-20.566l.625-6.124 20.36-8.55h3.248v20.22l-.749 4.159-2.499 2.427Z",
    fill: "#18A2F7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M375.43 214.559v-23.055l1.757-.57 15.188 5.934 7.782 4.223V226.2l-1.632.914-21.338-9.816-1.757-2.739Z",
    fill: "#5DBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m395.42 179.68 4.792-0.803 20.053 7.454 2.396 3.325-22.449 9.403-20.683-8.371-0.882-2.752 16.773-8.256z",
    fill: "#1FB1F5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m400.15 205.21-23.734 10.934 22.227 10.479h4.521l21.223-10.479-24.237-10.934z",
    fill: "#3F8CFF",
    fillOpacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m422.402 185.988-19.633-8.483a7.322 7.322 0 0 0-5.907.043l-18.633 8.374a7.243 7.243 0 0 0-4.284 6.614l.012 5.73-.008 15.899a7.238 7.238 0 0 0 4.287 6.605l18.736 8.41a7.327 7.327 0 0 0 5.904.041l19.604-8.474a7.243 7.243 0 0 0 4.382-6.667l-.078-21.476a7.244 7.244 0 0 0-4.382-6.616Zm-19.607-4.85 15.757 6.807c.76.329.732 1.411-.044 1.7l-15.269 5.686a9.31 9.31 0 0 1-6.612-.044l-14.669-5.686a.915.915 0 0 1-.045-1.69l14.975-6.73a7.33 7.33 0 0 1 5.907-.043Zm-24.25 10.706 13.807 5.352a9.201 9.201 0 0 1 5.893 8.568l.01 18.927a.922.922 0 0 1-1.302.835l-15.375-6.9a7.24 7.24 0 0 1-4.288-6.605l.008-13.757-.012-5.564a.921.921 0 0 1 1.257-.856h.002Zm23.052 32.91-.01-18.877c-.002-3.838 2.394-7.274 6.009-8.621l14.6-5.437a.922.922 0 0 1 1.246.855l.069 19.232a7.24 7.24 0 0 1-4.381 6.667l-16.244 7.021a.922.922 0 0 1-1.29-.84h.001Z",
    fill: "#fff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "logoThatMoves"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Ellipse 1",
    cx: 287.78,
    cy: 156.99,
    r: 26.458,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Frame",
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M272.959 150.352c.029-8.185 6.67-14.354 14.857-14.354 8.189 0 14.831 6.171 14.858 14.357v.048l-.313 14.971-12.069 12.53v-20.557l7.059-1.649 2.07-4.597-11.574 2.444h-.045l-11.525-2.444 1.959 4.595 6.943 1.649v20.556l-11.957-12.531-.263-14.967v-.051Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m292.52 136.71-1.868 5.396h2.673l-2.348 5.494 5.988-6.62h-2.728l1.39-2.896a14.786 14.786 0 0 0-3.107-1.374z",
    fill: "url(#au)"
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 143.47,
    y: 234.52,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#at)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "as",
    className: "h",
    x: 167,
    y: 366,
    width: 54,
    height: 25,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m167.3 366.94h52.916v23.129h-52.916v-23.129z",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "Group",
    mask: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M219.48 376.99c-.449-.558-1.146-1.121-2.033-1.658.194-.022.385-.065.565-.134.971-.374 1.42-.987 1.499-2.05.056-.748-.335-1.545-1.129-2.307-.82-.788-2.83-2.247-7.075-3.174-3.673-.803-7.99-.947-12.485-.417-7.028.828-12.2 2.929-15.302 4.547-.525.273-1.008.542-1.452.8a3.165 3.165 0 0 0-1.316-1.251c-1.203-.612-3.164-.561-4.429.739a3.806 3.806 0 0 0-.906 1.589 3.307 3.307 0 0 0-1.856-.564c-1.905 0-3.196 1.174-3.631 2.336a3.92 3.92 0 0 0 .033 2.849c-.588.141-1.566.529-2.17 1.584-1.006 1.754-.359 3.669.848 4.507.89.619 2.066.603 2.889.484a7.748 7.748 0 0 0 .195 2.083c.432 1.772 1.519 2.829 3.143 3.056.276.039.536.057.782.057 1.795 0 2.836-.947 3.621-1.662.306-.279.57-.519.819-.653.258-.138.916-.144 1.613-.15 1.748-.017 4.387-.041 5.362-2.219.165-.368.264-.728.312-1.076 2.169-.368 5.271-.692 8.764-.44 4.058.293 7.039 1.656 9.435 2.75 1.582.723 2.831 1.294 3.919 1.324l.173.003c.98 0 1.67-.244 2.221-.78.453-.441.714-1.184.651-1.852a4.122 4.122 0 0 0 2.022.516c.704 0 1.352-.166 1.835-.393.61-.286 1.095-.907 1.297-1.661.24-.892.055-1.867-.517-2.763.196.029.39.044.578.044.914 0 1.709-.33 2.122-.953.473-.713.534-1.952-.397-3.111Zm-35.615-4.598c3.046-1.585 8.128-3.645 15.037-4.459 6.63-.781 15.406-.049 19.005 3.404.641.615.959 1.224.919 1.759-.059.789-.347 1.185-1.061 1.46-.885.34-2.246-.22-2.259-.226l-.023-.007a24.89 24.89 0 0 0-2.749-1.01c-2.671-.814-7.113-1.74-13.102-1.534-5.832.202-10.605 1.421-13.512 2.375-.042-.03-.082-.061-.126-.088-.785-.496-2.115-.798-3.458-.177a4.262 4.262 0 0 0-.178-.663c.458-.269.96-.549 1.507-.834Zm2.792 12.044c-.048.223-.12.445-.219.665-.795 1.776-2.983 1.796-4.741 1.812-.852.008-1.525.014-1.932.232-.324.174-.631.454-.956.75-.837.761-1.878 1.709-3.846 1.433-3.223-.451-2.74-4.653-2.718-4.831a.346.346 0 0 0-.413-.38c-.546.117-1.912.321-2.8-.296-1.196-.83-1.265-2.515-.644-3.6.701-1.221 2.047-1.315 2.103-1.318a.346.346 0 0 0 .271-.529c-.007-.012-.746-1.199-.189-2.686.262-.702 1.187-1.89 2.987-1.89 1.147 0 1.795.704 1.82.733a.344.344 0 0 0 .6-.2c.001-.01.089-.999.835-1.766 1.162-1.194 2.84-1.005 3.626-.605.493.25.82.616 1.038.99.126.217.215.436.278.638.142.455.152.818.152.85a.357.357 0 0 0 .049.174.346.346 0 0 0 .478.114c1.027-.648 2.08-.578 2.81-.274.14.058.268.124.382.196.125.079.241.174.347.278.648.634.957 1.664.928 2.275-.004.066-.009.13-.016.193-.031.294-.102.55-.199.774-.523 1.209-1.81 1.448-1.876 1.459a.345.345 0 0 0-.146.617c.006.004.394.293.831.781.156.174.318.374.471.595.02.03.041.058.061.089.449.678.68 1.352.695 2.016.005.239-.017.476-.067.711Zm24.753 2.234c-.45.439-.999.607-1.896.583-.949-.026-2.142-.572-3.652-1.262-2.317-1.059-5.49-2.51-9.672-2.812-3.475-.251-6.577.061-8.786.426-.045-.812-.352-1.542-.73-2.145 9.386-2.049 18.038-.964 24.751 3.148.312.207.407.525.431.758.046.459-.142 1.007-.447 1.304h.001Zm5.621-3.075c-.148.552-.503 1.019-.925 1.216-.82.385-2.202.563-3.398-.199a26.42 26.42 0 0 0-.91-.582l-.016-.011-.013-.007c-6.933-4.24-15.863-5.331-25.527-3.16a7.337 7.337 0 0 0-.675-.735c.743-.308 1.621-.976 1.921-2.179 2.59-.712 6.778-1.569 12.022-1.602 5.098-.032 9.056.959 11.48 1.795 3.257 1.125 5.012 2.385 5.524 3.123.533.767.717 1.598.518 2.341h-.001Zm2.274-3.874c-.417.629-1.654.917-3.016.326-1.083-.887-2.904-1.817-5.076-2.566-2.474-.854-6.512-1.865-11.708-1.833-5.118.032-9.257.842-11.916 1.551.021-.653-.257-1.719-.9-2.507a48.8 48.8 0 0 1 12.967-2.225c10.274-.355 17.465 2.684 19.289 4.955.71.883.684 1.811.36 2.3v-.001Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M175.017 378.44c.3-.349.447-.793.413-1.252a1.711 1.711 0 0 0-.593-1.177 1.71 1.71 0 0 0-1.25-.414 1.723 1.723 0 0 0 .254 3.436 1.709 1.709 0 0 0 1.176-.593Zm-.512-.771h-.002a.295.295 0 0 1-.294-.293c-.002-.058-.024-.237-.11-.345-.136-.171-.289-.196-.295-.197a.293.293 0 0 1-.26-.323.298.298 0 0 1 .327-.263c.04.004.399.051.689.416.228.286.237.665.238.708a.296.296 0 0 1-.293.297Zm3.384-1.031a1.708 1.708 0 0 0 1.251.413 1.71 1.71 0 0 0 1.176-.593c.3-.349.446-.793.412-1.252a1.717 1.717 0 0 0-1.842-1.591 1.724 1.724 0 0 0-.996 3.023h-.001Zm.997-2.063a.295.295 0 0 1 .334-.25 1.008 1.008 0 0 1 .702.497c.009.017.02.032.029.051.195.419.058.786.042.827a.297.297 0 0 1-.384.162.295.295 0 0 1-.163-.383.501.501 0 0 0-.029-.356.413.413 0 0 0-.282-.214.292.292 0 0 1-.228-.179.288.288 0 0 1-.021-.155Zm-8.092 5.544c-.404.03-.773.216-1.037.523a1.507 1.507 0 0 0-.364 1.104c.03.404.215.773.522 1.038a1.503 1.503 0 0 0 1.103.364c.404-.03.772-.216 1.036-.523a1.52 1.52 0 0 0-1.261-2.506h.001Zm1.043 1.792a.297.297 0 0 1-.341.24.295.295 0 0 1-.24-.342c0-.002.022-.175-.105-.331a.37.37 0 0 0-.241-.128.294.294 0 0 1-.28-.307.299.299 0 0 1 .309-.282.954.954 0 0 1 .67.345 1.06 1.06 0 0 1 .227.805h.001Zm13.31-3.967a1.514 1.514 0 0 0-1.335-2.209c-.042 0-.083 0-.125.003a1.514 1.514 0 0 0-1.037.523 1.51 1.51 0 0 0-.364 1.104c.03.405.216.773.522 1.038a1.505 1.505 0 0 0 1.334.327 1.518 1.518 0 0 0 1.006-.787l-.001.001Zm-.522-.28a.293.293 0 0 1-.373.186.296.296 0 0 1-.185-.374.52.52 0 0 0 .002-.319.381.381 0 0 0-.187-.218.295.295 0 0 1 .289-.514.974.974 0 0 1 .459.552 1.1 1.1 0 0 1-.005.687Zm-1.889 4.113v-.001c-.352-.874-.984-1.513-1.828-1.847-1.332-.529-2.897-.212-3.917.262-2.499 1.159-2.855 3.27-2.485 4.407.262.801.864 1.274 1.585 1.274.112 0 .227-.012.344-.035.682-.136 1.126-.432 1.556-.718.6-.4 1.221-.813 2.632-.911.992-.069 1.668-.366 2.009-.884.167-.254.246-.558.234-.889a2.157 2.157 0 0 0-.125-.645l-.005-.013Zm-2.049.024c-.545-.554-1.391-.582-1.4-.582a.295.295 0 0 1-.287-.301.293.293 0 0 1 .299-.289c.045.001 1.092.03 1.807.758a.295.295 0 0 1-.419.414Zm.781 1.196a.295.295 0 0 1-.334-.249 2.134 2.134 0 0 0-.036-.187.295.295 0 0 1 .572-.139c.019.078.035.159.047.241a.294.294 0 0 1-.249.334Z",
    fill: "#FFB1B5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.424 384.61c-6.713-4.111-15.364-5.197-24.75-3.147.378.603.685 1.332.73 2.145 2.208-.366 5.31-.677 8.786-.426 4.181.302 7.354 1.752 9.671 2.811 1.511.691 2.704 1.236 3.653 1.262.896.025 1.445-.144 1.895-.582.305-.297.493-.845.447-1.305-.024-.232-.119-.55-.431-.757l-.001-.001Z",
    fill: "#9DD9AF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M199.653 372.467a48.8 48.8 0 0 0-12.967 2.225c.643.788.921 1.854.9 2.508 2.659-.71 6.798-1.52 11.916-1.552 5.196-.032 9.234.979 11.708 1.833 2.173.75 3.993 1.679 5.076 2.566 1.362.591 2.6.303 3.016-.326.324-.488.349-1.416-.36-2.299-1.825-2.271-9.015-5.31-19.29-4.955h.001Z",
    fill: "#9DDEF7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M185.998 374.066c.043.027.084.058.125.088 2.908-.954 7.68-2.174 13.512-2.375 5.99-.206 10.431.72 13.102 1.534.986.3 1.911.642 2.75 1.01l.022.007c.014.006 1.375.566 2.26.226.714-.275 1.001-.671 1.06-1.46.04-.535-.278-1.144-.919-1.759-3.599-3.453-12.374-4.185-19.004-3.404-6.91.814-11.991 2.874-15.038 4.459-.509.265-1.012.543-1.507.834.088.243.144.472.178.663 1.343-.621 2.673-.319 3.459.177Z",
    fill: "#A1FCE7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.989 378.131c-2.424-.837-6.382-1.828-11.48-1.795-5.244.033-9.432.889-12.022 1.601-.3 1.203-1.178 1.871-1.921 2.179.199.189.437.438.675.735 9.664-2.171 18.594-1.079 25.527 3.16l.013.007.016.012a27.334 27.334 0 0 1 .91.581c1.196.763 2.578.584 3.398.2.422-.198.777-.664.925-1.217.199-.742.016-1.574-.517-2.341-.513-.738-2.267-1.998-5.525-3.122h.001Z",
    fill: "#FFE66A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M185.966 381.622a6.24 6.24 0 0 0-.47-.595c-.438-.488-.826-.777-.831-.781a.347.347 0 0 1-.12-.158.348.348 0 0 1 .265-.459c.066-.011 1.353-.25 1.876-1.459a2.689 2.689 0 0 0 .215-.967c.029-.611-.28-1.641-.928-2.275a2.064 2.064 0 0 0-.347-.278 2.482 2.482 0 0 0-.382-.196c-.73-.304-1.783-.374-2.81.274a.348.348 0 0 1-.348.011.362.362 0 0 1-.13-.125.357.357 0 0 1-.049-.174c0-.032-.01-.395-.152-.85a3.123 3.123 0 0 0-.278-.638 2.504 2.504 0 0 0-1.038-.99c-.786-.4-2.464-.589-3.626.605a3.17 3.17 0 0 0-.834 1.766.352.352 0 0 1-.234.299.345.345 0 0 1-.366-.099c-.026-.028-.674-.733-1.82-.733-1.801 0-2.725 1.188-2.988 1.89-.556 1.487.182 2.675.189 2.686a.345.345 0 0 1-.271.529c-.056.003-1.402.097-2.102 1.318-.622 1.085-.553 2.77.643 3.6.888.617 2.254.413 2.801.297a.336.336 0 0 1 .304.083.342.342 0 0 1 .108.296c-.022.178-.505 4.38 2.718 4.831 1.968.276 3.01-.672 3.846-1.433.325-.296.632-.576.956-.75.407-.218 1.08-.224 1.932-.232 1.758-.016 3.947-.036 4.741-1.812.099-.22.171-.442.219-.665.05-.235.073-.473.067-.711-.015-.664-.246-1.338-.695-2.017l-.061-.088Zm-3.318-5.357a1.5 1.5 0 0 1 1.036-.523c.042-.003.084-.004.126-.003a1.51 1.51 0 0 1 1.335 2.208 1.52 1.52 0 0 1-1.351.828c-.363 0-.71-.128-.988-.368a1.51 1.51 0 0 1-.523-1.038c-.03-.405.1-.796.364-1.104h.001Zm-3.765-2.647a1.713 1.713 0 0 1 1.59.811c.145.233.232.499.253.78.034.459-.112.903-.412 1.252a1.711 1.711 0 0 1-1.306.598c-.412 0-.806-.146-1.121-.418a1.723 1.723 0 0 1 .996-3.023Zm-6.83 9.01a1.509 1.509 0 0 1-1.152.527 1.514 1.514 0 0 1-1.51-1.406c-.03-.405.099-.797.364-1.104a1.509 1.509 0 0 1 1.037-.523 1.52 1.52 0 0 1 1.261 2.506Zm1.656-3.587c-.411 0-.805-.146-1.12-.418a1.724 1.724 0 0 1 .996-3.022c.458-.034.902.112 1.25.413.348.3.559.718.592 1.177.034.459-.112.904-.412 1.252a1.71 1.71 0 0 1-1.306.598Zm8.921 4.286c-.341.517-1.016.814-2.009.883-1.411.098-2.032.512-2.632.912-.43.286-.874.582-1.556.718a1.785 1.785 0 0 1-.344.035c-.721 0-1.323-.473-1.584-1.275-.37-1.136-.014-3.247 2.484-4.406 1.02-.474 2.585-.791 3.917-.262.845.334 1.477.973 1.828 1.847v.001l.005.013c.077.221.119.438.126.644.011.331-.068.636-.235.89Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M171.609 381.106a.961.961 0 0 0-.669-.345.299.299 0 0 0-.309.283.292.292 0 0 0 .28.306c.006.001.148.013.241.128.127.157.105.329.105.332a.295.295 0 1 0 .58.101 1.06 1.06 0 0 0-.227-.805h-.001Zm2.262-4.858a.297.297 0 0 0-.326.263.291.291 0 0 0 .259.323.52.52 0 0 1 .296.197.664.664 0 0 1 .109.345.294.294 0 0 0 .295.293h.002a.295.295 0 0 0 .292-.297c0-.042-.01-.421-.238-.708-.29-.365-.649-.412-.689-.416Zm5.264-1.339c.002 0 .2.036.282.214.011.021.018.042.025.063.05.161.005.291.005.293a.294.294 0 0 0 .546.221 1.086 1.086 0 0 0-.042-.827c-.009-.019-.02-.034-.029-.051a1.01 1.01 0 0 0-.702-.497.295.295 0 0 0-.334.25.288.288 0 0 0 .021.155.29.29 0 0 0 .228.179Zm4.748 2.031a.377.377 0 0 1 .186.217.513.513 0 0 1-.002.319.295.295 0 0 0 .558.189c.053-.156.096-.402.005-.687a.966.966 0 0 0-.459-.553.295.295 0 0 0-.288.515Zm-2.212 5.482a.295.295 0 0 0-.573.139c.015.06.027.123.036.187a.295.295 0 1 0 .583-.085 2.495 2.495 0 0 0-.046-.241Zm-.564-1.035c-.716-.728-1.763-.757-1.807-.758a.295.295 0 0 0-.012.59c.008 0 .855.028 1.399.582a.293.293 0 0 0 .417.003.295.295 0 0 0 .003-.417Z",
    fill: "#fff"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "lineWithLogo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "m299.71 494.63c112.88 0 204.39-91.432 204.39-204.22s-91.508-204.22-204.39-204.22-204.39 91.431-204.39 204.22 91.508 204.22 204.39 204.22z",
    stroke: "#0FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    className: "logoThatMoves"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.49,
    y: 460.96,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.49,
    y: 460.96,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#aq)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 471.55,
    y: 211.67,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 82.318,
    y: 337.49,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 410.4,
    y: 419.8,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 356.31,
    y: 83.49,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 145.82,
    y: 96.425,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logoThatMoves",
    d: "m88.195 174.04h52.916v52.916h-52.916z",
    fill: "url(#ak)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "lineWithLogo"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "m299.71 562.76c150.51 0 272.52-121.94 272.52-272.35s-122.01-272.35-272.52-272.35-272.52 121.93-272.52 272.35 122.01 272.35 272.52 272.35z",
    stroke: "#0FF",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 41.156,
    y: 119.94,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#aj)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 256.35,
    y: 537.4,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#ai)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "logoThatMoves"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Frame",
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m597.94 244.91v3.125c0 2.148-0.565 4.185-1.611 5.971l-8.817 15.122-9.214-15.764c-2.204-3.767-8.563-3.767-10.767 0l-9.214 15.708-8.761-15.011c-1.074-1.841-1.667-3.934-1.667-6.026v-3.125c0-2.735 2.261-4.967 5.03-4.967h39.991c2.769 0 5.03 2.232 5.03 4.967z",
    fill: "#7B78FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m587.51 269.13-9.214 15.709c-1.102 1.897-3.165 3.069-5.398 3.069-2.232 0-4.267-1.2-5.398-3.069l-9.213-15.764 9.213-15.709c2.205-3.767 8.564-3.767 10.768 0l9.242 15.764z",
    fill: "#12429F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M597.942 290.141v3.125c0 2.734-2.261 4.966-5.03 4.966h-39.991c-2.769.028-5.03-2.204-5.03-4.938v-3.181c0-2.093.565-4.129 1.611-5.915l8.817-15.123 9.214 15.765c1.102 1.897 3.165 3.069 5.398 3.069 2.232 0 4.267-1.2 5.398-3.069l9.213-15.709 8.761 15.011a11.98 11.98 0 0 1 1.639 5.999Z",
    fill: "#A0D2EB"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "logoThatMoves"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ag",
    className: "t",
    x: 125,
    y: 496,
    width: 54,
    height: 54,
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "clip0_45998"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m178.62 523.19c0-14.613-11.846-26.459-26.459-26.459-14.612 0-26.458 11.846-26.458 26.459 0 14.612 11.846 26.458 26.458 26.458 14.613 0 26.459-11.846 26.459-26.458z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "Group",
    mask: "url(#ag)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m152.16 549.65c14.613 0 26.459-11.846 26.459-26.458 0-14.613-11.846-26.459-26.459-26.459-14.612 0-26.458 11.846-26.458 26.459 0 14.612 11.846 26.458 26.458 26.458z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m152.16 545c12.044 0 21.806-9.763 21.806-21.806 0-12.044-9.762-21.807-21.806-21.807-12.043 0-21.806 9.763-21.806 21.807 0 12.043 9.763 21.806 21.806 21.806zm0 4.652c14.613 0 26.458-11.846 26.458-26.458 0-14.613-11.845-26.459-26.458-26.459-14.612 0-26.458 11.846-26.458 26.459 0 14.612 11.846 26.458 26.458 26.458z",
    clipRule: "evenodd",
    fill: "#1A1A1A",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m152.11 535.25c4.546 0 8.482 2.161 10.451 5.929 0 0 1.221-0.741 2.142-1.478s1.618-1.422 1.618-1.422c-2.863-4.921-8.108-7.759-14.211-7.759-6.028 0-11.19 3.074-14.078 7.894 0 0 0.852 0.781 1.829 1.524a16.086 16.086 0 0 0 1.955 1.262c2.001-3.669 5.821-5.95 10.294-5.95z",
    fill: "url(#af)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M152.117 516.623c5.226 0 9.986 2.326 13.015 6.113 0 0-1.586.118-2.745.365-1.158.247-2.78.935-2.78.935a11.748 11.748 0 0 0-7.49-2.682 11.748 11.748 0 0 0-7.49 2.682s-1.622-.688-2.78-.935c-1.159-.247-2.669-.365-2.669-.365 3.028-3.787 7.713-6.113 12.939-6.113Z",
    fill: "url(#ae)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M152.109 502.622c5.226 0 9.885 2.425 12.914 6.212 0 0-1.485.019-2.644.266-1.158.247-2.78.935-2.78.935a11.748 11.748 0 0 0-7.49-2.682 11.748 11.748 0 0 0-7.49 2.682s-1.622-.688-2.78-.935c-1.159-.247-2.644-.266-2.644-.266a16.496 16.496 0 0 1 12.914-6.212Z",
    fill: "url(#ad)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M166.439 523.581c2.313 0 4.426.136 6.419 1.016 0 0-.093 1.459-.321 2.563a40.66 40.66 0 0 1-.567 2.318c-1.635-.888-3.546-1.166-5.531-1.166-2.765 0-5.305.977-7.302 2.609 0 0-1.25-.549-2.508-.853a31.644 31.644 0 0 0-2.75-.501c2.991-3.657 7.507-5.986 12.56-5.986Z",
    fill: "url(#ac)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M137.863 523.581c-2.313 0-4.38.304-6.373 1.184 0 0 .168 1.459.396 2.563.229 1.104.565 2.171.565 2.171 1.635-.887 3.427-1.187 5.412-1.187 2.765 0 5.305.977 7.301 2.609 0 0 1.251-.549 2.509-.853a31.573 31.573 0 0 1 2.75-.501c-2.991-3.657-7.507-5.986-12.56-5.986Z",
    fill: "url(#ab)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M145.594 516.852c-2.153-1.603-4.572-2.494-7.503-2.494-1.886 0-3.725.542-5.306 1.329 0 0 .887-2.112 1.738-3.546a18.727 18.727 0 0 1 1.898-2.606 14.167 14.167 0 0 1 1.67-.104c5.33 0 10.114 2.416 13.137 6.333-2.168.043-3.574.243-5.634 1.088Z",
    fill: "url(#aa)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M158.763 516.852c2.152-1.603 4.571-2.494 7.503-2.494 1.885 0 3.724.542 5.306 1.329 0 0-.888-2.112-1.738-3.546-.851-1.435-1.899-2.606-1.899-2.606a14.15 14.15 0 0 0-1.669-.104c-5.33 0-10.115 2.416-13.137 6.333 2.168.043 3.573.243 5.634 1.088Z",
    fill: "url(#bj)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M152.202 536.753c3.804 0 7.207 2.075 9.111 5.061-.389.221-1.166.596-1.166.596-1.675-2.604-4.619-4.349-7.945-4.349-3.335 0-6.272 1.759-7.945 4.374 0 0-.888-.406-1.177-.6 1.895-3.029 5.285-5.082 9.122-5.082Z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M152.172 539.419c2.728 0 5.244 1.449 6.609 3.426-.278.146-.892.356-.892.356-1.202-1.724-3.332-2.916-5.717-2.916-2.391 0-4.596 1.25-5.796 2.981-.293-.074-.662-.227-.911-.323 1.359-2.006 3.955-3.524 6.707-3.524Zm-.002-13.978c1.331 0 2.612.346 3.733.929l-.69.628a6.984 6.984 0 0 0-3.043-.69c-1.044 0-2.074.28-2.979.693l-.761-.622c1.13-.587 2.417-.938 3.74-.938Z",
    fill: "#1A1A1A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M141.191 533.374c-1.121-.583-2.494-.963-3.826-.963a8.077 8.077 0 0 0-3.267.711l.51.752c.85-.359 1.797-.597 2.757-.597 1.102 0 2.13.27 3.056.713l.77-.616Zm22.034 0c1.121-.583 2.494-.963 3.825-.963 1.142 0 2.257.262 3.268.711l-.51.752c-.85-.359-1.798-.597-2.758-.597-1.101 0-2.129.27-3.055.713l-.77-.616Zm-11.056-21.802c1.12 0 2.204.245 3.188.67l-.725.64a6.969 6.969 0 0 0-2.463-.444c-.823 0-1.637.175-2.387.45l-.79-.645a8.055 8.055 0 0 1 3.177-.671Zm-13.893 6.929c1.12 0 2.24.269 3.224.694l-.853.609a6.463 6.463 0 0 0-2.371-.437c-.823 0-1.636.175-2.387.45l-.789-.645a8.05 8.05 0 0 1 3.176-.671Zm28.03 0c1.12 0 2.128.239 3.112.664l-.758.63a6.368 6.368 0 0 0-2.354-.428c-.823 0-1.694.151-2.444.427l-.796-.601c.987-.425 2.132-.692 3.24-.692Z",
    clipRule: "evenodd",
    fill: "#1A1A1A",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M146.086 524.811a10.678 10.678 0 0 1 6.111-1.924c2.194 0 4.255.69 5.971 1.847l-1.125.806a9.38 9.38 0 0 0-9.756.047l-1.201-.776Zm6.114-15.817c2.026 0 4.085.692 5.717 1.693l-1.283.727a9.381 9.381 0 0 0-4.434-1.111c-1.605 0-3.172.449-4.497 1.164l-1.295-.74c1.646-1.027 3.721-1.733 5.792-1.733Zm13.98 6.932c2.026 0 3.996.622 5.628 1.623l-1.255.745c-1.324-.708-2.774-1.06-4.373-1.06a9.398 9.398 0 0 0-4.461 1.123l-1.301-.711c1.646-1.027 3.691-1.72 5.762-1.72Zm-27.96 0c-2.025 0-3.996.622-5.628 1.623l1.255.745c1.324-.708 2.774-1.06 4.373-1.06 1.605 0 3.137.408 4.461 1.123l1.301-.711c-1.646-1.027-3.691-1.72-5.762-1.72Zm28.747 13.928c1.595 0 3.119.357 4.492.989 0 0-.022.094-.166.467-.144.374-.316.709-.316.709s-2.579-.881-4.01-.881c-1.79 0-3.466.497-4.893 1.356 0 0-.217-.163-.624-.417a4.53 4.53 0 0 0-.598-.332 10.817 10.817 0 0 1 6.115-1.891Zm-29.496 0c-1.595 0-3.119.357-4.492.989a8.247 8.247 0 0 0 .482 1.176s2.579-.881 4.01-.881c1.79 0 3.466.497 4.893 1.356 0 0 .217-.163.624-.417a4.53 4.53 0 0 1 .598-.332 10.817 10.817 0 0 0-6.115-1.891Z",
    fill: "#1A1A1A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M170.254 522.899c-1.761-.277-3.174-.221-3.174-.221a16.401 16.401 0 0 1 5.193-4.277s.33.831.54 2.515c.211 1.685.103 2.676.103 2.676s-.901-.417-2.662-.693Z",
    fill: "url(#bi)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M134.045 522.899c1.762-.277 3.174-.221 3.174-.221a16.39 16.39 0 0 0-5.193-4.277s-.33.831-.54 2.515c-.21 1.685-.103 2.676-.103 2.676s.901-.417 2.662-.693Z",
    fill: "url(#bh)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "Group",
    opacity: 0.3,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m178.66 496.76h-52.916v52.916h52.916v-52.916z",
    fill: "url(#bg)"
  }))))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 41.156,
    y: 409.22,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#bf)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 356.3,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#be)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 491.54,
    y: 99.952,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#bd)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    x: 376.3,
    y: 517.4,
    width: 52.916,
    height: 52.916,
    rx: 26.458,
    fill: "url(#bc)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "logoThatMoves"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "m186 32.859c0-14.613 11.647-26.657 26.26-26.657 14.612 0 26.656 11.647 26.656 26.26 0 14.612-11.647 26.656-26.259 26.656-14.613 0-26.657-11.647-26.657-26.26z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Group 1000004043"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.721 15.025c0-.153.125-.277.278-.277h6.038c.154 0 .278.122.278.276a.28.28 0 0 0 .281.28l.082-.001.468-.003.24-.003c.135 0 .271.001.406.005.128.003.208-.024.27.088.136.243.266.587.544.587h.894c.155 0 .28.123.28.278a.28.28 0 0 0 .279.281h.112c.154 0 .279.123.279.277a.28.28 0 0 0 .277.282c.155 0 .282.125.282.28v.111c0 .154.123.28.277.28a.28.28 0 0 1 .282.277.28.28 0 0 0 .279.281h.056c.185 0 .335.15.335.336v.614c0 .154.123.28.278.28a.28.28 0 0 1 .281.279v1.118c0 .154.123.279.277.279.155 0 .282.125.282.28v2.402c0 .185.147.335.333.335.185 0 .337.15.337.336v4.687c0 .135-.09.253-.221.285a.297.297 0 0 0-.226.287v1.334c0 .124.099.224.222.224.124 0 .225.1.225.224v4.693a.333.333 0 0 1-.332.336.337.337 0 0 0-.338.335v.614c0 .155-.123.28-.277.28a.281.281 0 0 0-.282.28v3.017c0 .154-.123.28-.277.28a.281.281 0 0 0-.282.279v1.732a.333.333 0 0 1-.332.335.337.337 0 0 0-.338.335v.615c0 .154-.123.28-.278.28a.28.28 0 0 0-.281.277.28.28 0 0 1-.277.281.281.281 0 0 0-.282.28v.307c0 .301.229.554.528.584l.36.036c.138.013.252.11.285.244a.33.33 0 0 0 .286.248l.624.063c.15.015.264.139.264.29 0 .162.131.295.293.295h1.216c.154 0 .279.123.279.277 0 .155.125.282.28.282h1.732c.185 0 .335.148.335.333 0 .185.15.337.335.337h.615c.154 0 .279.123.279.278 0 .154.125.281.28.281h1.229c.154 0 .28.123.28.277 0 .155.125.282.279.282h.615c.123 0 .223.098.223.222 0 .123-.1.225-.223.225h-35.427c-.926 0-1.677-.75-1.677-1.676V47.94a.56.56 0 0 1 .559-.559h.279c.155 0 .28-.123.28-.277 0-.154.125-.282.279-.282h.615a.333.333 0 0 0 .335-.332c0-.185.15-.338.335-.338h1.16c.162 0 .293-.13.293-.291 0-.15.114-.28.264-.294l.629-.063a.319.319 0 0 0 .279-.24.324.324 0 0 1 .291-.245l1.168-.078a.356.356 0 0 0 .328-.286.362.362 0 0 1 .353-.291h.544a.277.277 0 0 0 .279-.277c0-.155.125-.282.28-.282h.67c.154 0 .28-.123.28-.277 0-.154.125-.282.279-.282h.443a.395.395 0 0 0 .395-.395v-.084c0-.051.02-.1.056-.135a.19.19 0 0 1 .135-.056h.085a.395.395 0 0 0 .395-.395v-7.54a.335.335 0 0 0-.336-.335h-.055a.278.278 0 0 1-.28-.278.28.28 0 0 0-.277-.281.28.28 0 0 1-.282-.277.281.281 0 0 0-.279-.282.287.287 0 0 1-.287-.275l-.097-3.58a.349.349 0 0 0-.281-.335.355.355 0 0 1-.285-.346v-1.108a.278.278 0 0 0-.277-.28.281.281 0 0 1-.282-.279v-1.9c0-.154.123-.279.278-.279a.281.281 0 0 0 .281-.28v-1.731c0-.186.148-.336.333-.336.185 0 .338-.15.338-.335v-1.173c0-.155.123-.28.277-.28a.281.281 0 0 0 .281-.28v-.558c0-.154.123-.28.278-.28a.281.281 0 0 0 .281-.279v-.056c0-.185.15-.335.335-.335h.056c.155 0 .28-.123.28-.277a.28.28 0 0 1 .277-.282.28.28 0 0 0 .281-.277.28.28 0 0 1 .278-.282.281.281 0 0 0 .281-.279v-.056c0-.185.15-.335.336-.335h.055c.155 0 .28-.123.28-.277a.28.28 0 0 1 .277-.282.28.28 0 0 0 .282-.277c0-.154.125-.282.279-.282h.443a.393.393 0 0 0 .395-.393c0-.105.03-.23.129-.264a.983.983 0 0 1 .238-.024 835.726 835.726 0 0 0 .622.007.236.236 0 0 0 .24-.237v-.04Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.725 15.025c0-.153.124-.277.277-.277h6.039c.153 0 .278.122.278.276a.28.28 0 0 0 .28.28l.082-.001.469-.003.239-.003c.136 0 .271.001.406.005.129.003.208-.024.271.088.135.243.266.587.543.587h.895c.154 0 .279.123.279.278a.28.28 0 0 0 .279.281h.112c.154 0 .28.123.28.277a.28.28 0 0 0 .277.282.28.28 0 0 1 .281.28v.111c0 .154.123.28.278.28a.28.28 0 0 1 .281.277c0 .154.125.281.28.281h.055c.186 0 .336.15.336.336v.614c0 .154.123.28.277.28a.28.28 0 0 1 .281.279v1.118c0 .154.123.279.278.279.154 0 .281.125.281.28v2.402c0 .185.148.335.333.335.185 0 .338.15.338.336v4.687a.294.294 0 0 1-.222.285.297.297 0 0 0-.225.287v1.334c0 .124.098.224.222.224.123 0 .225.1.225.224v4.693a.333.333 0 0 1-.333.336.338.338 0 0 1-.338-.336v-1.564a1.9 1.9 0 0 0-1.9-1.9h-1.818a.748.748 0 0 1-.752-.747.757.757 0 0 0-.699-.756l-.083-.006a.843.843 0 0 1-.783-.84V28.94a.777.777 0 0 0-.776-.782.787.787 0 0 0-.788.782v1.565a.778.778 0 0 1-.777.782.782.782 0 0 0-.788.777c0 .432-.35.788-.782.788h-1.565a.777.777 0 0 1-.782-.777.782.782 0 0 0-.776-.788.788.788 0 0 1-.789-.782V28.55a.167.167 0 0 0-.167-.168h-.056a.111.111 0 0 1-.112-.11.113.113 0 0 0-.112-.113h-2.179a.391.391 0 0 0-.391.391v.28c0 .061.049.111.111.111s.112.05.112.112v9.723a.222.222 0 0 1-.222.223.225.225 0 0 1-.225-.223l-.005-3.67-.003-1.808-.002-1.746-.001-.665-.001-.934-.001-.276c0-.375.021-.735.065-1.099a.372.372 0 0 0-.364-.419h-.246a.111.111 0 0 0-.112.11c0 .063-.05.114-.112.114h-.782a.335.335 0 0 0-.335.335v.056a.278.278 0 0 1-.278.279.281.281 0 0 0-.281.28v3.348c0 .218.175.395.393.395.105 0 .231.03.263.13a1.1 1.1 0 0 1 .021.268.265.265 0 0 0 .266.273h.01c.153 0 .276.123.276.275a.283.283 0 0 1-.279.284h-.112a.277.277 0 0 1-.279-.278.28.28 0 0 0-.278-.281.28.28 0 0 1-.281-.277.281.281 0 0 0-.279-.282.286.286 0 0 1-.287-.275l-.097-3.58a.35.35 0 0 0-.281-.335.355.355 0 0 1-.286-.346v-1.108a.278.278 0 0 0-.277-.28.281.281 0 0 1-.281-.279v-1.9c0-.154.123-.279.277-.279a.28.28 0 0 0 .281-.28v-1.731c0-.186.148-.336.333-.336.185 0 .338-.15.338-.335v-1.173c0-.155.123-.28.277-.28a.281.281 0 0 0 .282-.28v-.558c0-.154.123-.28.277-.28a.282.282 0 0 0 .282-.279v-.056c0-.185.15-.335.335-.335h.056a.277.277 0 0 0 .279-.277.28.28 0 0 1 .277-.282.28.28 0 0 0 .282-.277.28.28 0 0 1 .277-.282.282.282 0 0 0 .282-.279v-.056c0-.185.15-.335.335-.335h.056a.277.277 0 0 0 .279-.277.28.28 0 0 1 .278-.282.28.28 0 0 0 .281-.277c0-.154.125-.282.279-.282h.443a.394.394 0 0 0 .396-.393c0-.105.029-.23.128-.264a.986.986 0 0 1 .239-.024l.31.004.311.003a.237.237 0 0 0 .241-.237v-.04Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.725 15.025c0-.153.124-.277.277-.277h6.039c.153 0 .278.122.278.276a.28.28 0 0 0 .28.28l.082-.001.469-.003.239-.003c.136 0 .271.001.406.005.129.003.208-.024.271.088.135.243.266.587.543.587h.895c.154 0 .279.123.279.278a.28.28 0 0 0 .279.281h.112c.154 0 .28.123.28.277a.28.28 0 0 0 .277.282.28.28 0 0 1 .281.28v.111c0 .154.123.28.278.28a.28.28 0 0 1 .004.559.282.282 0 0 0-.282.279v.503a.333.333 0 0 1-.332.335.337.337 0 0 0-.338.335v.056c0 .154-.123.28-.277.28a.28.28 0 0 0-.282.277.28.28 0 0 1-.277.281.28.28 0 0 0-.282.277.28.28 0 0 1-.277.282.282.282 0 0 0-.282.28v.055c0 .185-.15.335-.335.335h-4.749a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.281h-1.844a.334.334 0 0 1-.336-.333.337.337 0 0 0-.335-.338h-1.006a.335.335 0 0 0-.335.335v.056c0 .155-.123.28-.277.28a.282.282 0 0 0-.282.28v.502a.333.333 0 0 1-.332.335.337.337 0 0 0-.338.336v1.452c0 .31-.25.56-.559.56h-.223a.333.333 0 0 0-.336.332c0 .185-.15.338-.335.338h-1.173a.278.278 0 0 0-.28.277.281.281 0 0 1-.279.282h-.671a.277.277 0 0 0-.279.277.28.28 0 0 0 .279.281h1.509c.432 0 .782.35.782.783v.39a.391.391 0 0 1-.391.392h-.279a.111.111 0 0 0-.112.11c0 .063-.05.114-.112.114h-.782a.335.335 0 0 0-.335.335v.056a.278.278 0 0 1-.278.279.281.281 0 0 0-.281.28v3.348c0 .218.175.395.393.395.105 0 .231.03.263.13a1.1 1.1 0 0 1 .021.268.265.265 0 0 0 .266.273h.01c.153 0 .276.123.276.275a.283.283 0 0 1-.279.284h-.112a.277.277 0 0 1-.279-.278.28.28 0 0 0-.278-.281.28.28 0 0 1-.281-.277.281.281 0 0 0-.279-.282.286.286 0 0 1-.287-.275l-.097-3.58a.35.35 0 0 0-.281-.335.355.355 0 0 1-.286-.346v-1.108a.278.278 0 0 0-.277-.28.281.281 0 0 1-.281-.279v-1.9c0-.154.123-.279.277-.279a.281.281 0 0 0 .281-.28v-1.731c0-.186.148-.336.333-.336.185 0 .338-.15.338-.335v-1.173c0-.155.123-.28.277-.28a.281.281 0 0 0 .282-.28v-.558c0-.154.123-.28.277-.28a.282.282 0 0 0 .282-.279v-.056c0-.185.15-.335.335-.335h.056a.277.277 0 0 0 .279-.277.28.28 0 0 1 .277-.282.28.28 0 0 0 .282-.277.28.28 0 0 1 .277-.282.282.282 0 0 0 .282-.279v-.056c0-.185.15-.335.335-.335h.056a.277.277 0 0 0 .279-.277.28.28 0 0 1 .278-.282.28.28 0 0 0 .281-.277c0-.154.125-.282.279-.282h.443a.394.394 0 0 0 .396-.393c0-.105.029-.23.128-.264a.986.986 0 0 1 .239-.024l.31.004.311.003a.237.237 0 0 0 .241-.237v-.04Z",
    fill: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.586 36.93c0-.154.123-.28.278-.28.154 0 .281.126.281.28v1.9c0 .154.123.28.278.28a.28.28 0 0 1 .281.279v.614c0 .185.148.335.333.335.185 0 .338.15.338.336v1.62c0 .155.123.28.277.28a.28.28 0 0 1 .281.279v1.285c0 .185.148.335.333.335.185 0 .338.15.338.336v.503c0 .154.123.279.277.279.155 0 .282.125.282.28v.95c0 .308.246.558.554.558a.559.559 0 1 1 .004 1.118h-.894a.222.222 0 0 1-.223-.222c0-.124-.1-.225-.224-.225h-1.285a.277.277 0 0 0-.279.277c0 .154.125.282.279.282h.559c.154 0 .279.122.279.277 0 .154.125.281.28.281h1.229c.154 0 .279.123.279.278 0 .154.126.281.28.281h.67c.155 0 .28.123.28.277 0 .155.125.282.279.282h.056c.124 0 .224.098.224.222 0 .123-.1.225-.224.225h-15.869c-.926 0-1.677-.75-1.677-1.676v-1.118c0-.309.25-.559.559-.559h.279c.155 0 .28-.123.28-.277 0-.154.125-.282.279-.282h.615a.333.333 0 0 0 .335-.332c0-.186.15-.338.335-.338h1.16c.162 0 .293-.13.293-.291 0-.151.115-.28.264-.294l.629-.063a.321.321 0 0 0 .28-.242.321.321 0 0 1 .29-.243l1.168-.078a.356.356 0 0 0 .328-.286.362.362 0 0 1 .353-.291h.544a.277.277 0 0 0 .279-.278c0-.154.125-.281.28-.281h.67c.154 0 .28-.123.28-.277 0-.155.125-.282.279-.282h.443a.395.395 0 0 0 .395-.395v-.085c0-.05.02-.098.056-.134a.19.19 0 0 1 .135-.056h.248a.79.79 0 0 0 .79-.79V36.93Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.009 18.884a.56.56 0 0 1 .559-.559h.056c.339 0 .615.275.615.615v.335c0 .154.123.28.277.28a.28.28 0 0 1 .281.279v1.117c0 .155.123.28.278.28.154 0 .281.125.281.28v2.462a2.74 2.74 0 0 1-2.734 2.74l-.919.001h-.277c-2.905.003-5.808-.017-8.712-.063l-.258-.004-2.472-.041a.62.62 0 0 1-.609-.62v-.34c0-.155.123-.28.277-.28a.281.281 0 0 0 .282-.28v-2.29c0-.186.147-.336.333-.336.185 0 .337-.15.337-.335v-.503c0-.154.123-.28.278-.28a.281.281 0 0 0 .281-.279v-.056c0-.185.15-.335.335-.335h1.006c.185 0 .335.148.335.333 0 .185.151.338.336.338h1.844c.154 0 .279.123.279.277 0 .154.125.281.28.281h4.749c.185 0 .335-.15.335-.335v-.056c0-.154.123-.28.278-.28a.28.28 0 0 0 .281-.276.28.28 0 0 1 .278-.282.28.28 0 0 0 .281-.277.28.28 0 0 1 .277-.282.281.281 0 0 0 .282-.28v-.055c0-.185.147-.335.333-.335.185 0 .337-.15.337-.335v-.224Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.377 28.27c0-.062.05-.113.112-.113h1.564c.062 0 .112.05.112.111 0 .062.05.113.112.113h.056c.092 0 .168.075.168.167v1.956c0 .432.344.782.776.782.432 0 .788.345.788.777 0 .432.35.788.782.788h1.565a.777.777 0 0 0 .782-.776c0-.432.345-.789.777-.789.432 0 .788-.35.788-.782V28.94c0-.431.344-.782.776-.782.432 0 .789.35.789.782v1.262c0 .6.485 1.085 1.084 1.085h.188a.294.294 0 0 1 .292.293v.374c0 .496.402.898.898.898h2.846c.401 0 .726.325.726.727v.447a.277.277 0 0 1-.277.279.281.281 0 0 0-.281.28v.614a.333.333 0 0 1-.333.335.338.338 0 0 0-.338.335v.503c0 .155-.123.28-.277.28a.281.281 0 0 0-.282.28v.055c0 .185-.15.335-.335.335h-.615a.277.277 0 0 1-.279-.277.281.281 0 0 0-.279-.281h-.503a.336.336 0 0 1-.336-.336v-.056a.278.278 0 0 0-.277-.279.28.28 0 0 1-.281-.277.281.281 0 0 0-.28-.282h-1.229a.278.278 0 0 0-.28.277.281.281 0 0 1-.279.282h-1.173a.333.333 0 0 0-.336.333c0 .185-.15.338-.335.338h-1.173a.278.278 0 0 0-.28.277.28.28 0 0 1-.277.281.28.28 0 0 0-.282.278.281.281 0 0 1-.279.281h-.084a.305.305 0 0 1-.307-.305.31.31 0 0 1 .247-.303c.05-.01.096-.02.162-.032a.262.262 0 0 0 .19-.194c.038-.151-.08-.283-.237-.283h-.641a.278.278 0 0 0-.28.277.28.28 0 0 1-.277.281.28.28 0 0 0-.282.278.281.281 0 0 1-.279.281h-.112a.277.277 0 0 1-.279-.277.28.28 0 0 0-.277-.282.281.281 0 0 1-.282-.279v-.112a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.276.28.28 0 0 0-.277-.282.28.28 0 1 1-.004-.559.28.28 0 0 0 .281-.277.281.281 0 0 0-.279-.282h-.112a.277.277 0 0 1-.279-.277.28.28 0 0 0-.278-.281.281.281 0 0 1-.281-.28v-1.9a.278.278 0 0 0-.277-.279.281.281 0 0 1-.282-.28V29.89a.278.278 0 0 0-.277-.28.282.282 0 0 1-.282-.28v-.67a.28.28 0 0 1 .28-.28h.167a.11.11 0 0 0 .112-.11Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.661 46.49c0-.186.15-.339.335-.339h.559c.185 0 .335.148.335.333 0 .185.151.338.336.338h1.098c.143 0 .266.092.3.23a.318.318 0 0 0 .272.239l.636.063c.15.015.264.14.264.29 0 .162.131.296.293.296h1.216c.154 0 .279.123.279.277 0 .154.125.281.28.281h1.732c.185 0 .335.148.335.333 0 .185.15.338.335.338h.615c.154 0 .28.123.28.277 0 .154.125.282.279.282h1.229c.155 0 .28.123.28.277a.28.28 0 0 0 .279.281h.615c.123 0 .223.099.223.222 0 .124-.1.225-.223.225h-12.685a.166.166 0 0 1-.167-.166c0-.093.075-.169.167-.169h2.515a.333.333 0 0 0 .335-.333.337.337 0 0 0-.335-.337h-2.906a.894.894 0 0 1-.894-.894v-.615c0-.154.123-.28.277-.28a.281.281 0 0 0 .282-.279v-.28c0-.308.25-.558.559-.558h.335a.333.333 0 0 0 .335-.333Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.587 36.93c0-.154.123-.28.278-.28.154 0 .281.126.281.28v1.9c0 .154.123.28.277.28a.28.28 0 0 1 .282.279v.614c0 .185.147.335.333.335.185 0 .337.15.337.336v1.62c0 .155.123.28.278.28a.28.28 0 0 1 .281.279v1.285c0 .185.148.335.333.335.185 0 .338.15.338.336v.503c0 .154.123.279.277.279.154 0 .282.125.282.28V47.1c0 .154.123.28.277.28a.28.28 0 0 1 .281.276.281.281 0 0 1-.279.282h-1.229a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-3.576a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-.28a.559.559 0 0 1-.558-.558v-.392c0-.154.123-.279.277-.279a.28.28 0 0 0 .281-.277.28.28 0 0 1 .278-.282.281.281 0 0 0 .281-.28v-.672c0-.153.124-.277.277-.277h.041a.237.237 0 0 0 .237-.24l-.003-.312-.004-.31a1.51 1.51 0 0 1 .004-.077c.01-.21.234-.29.443-.29a.792.792 0 0 0 .793-.79V36.93Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.102 31.648a.31.31 0 0 1 .355-.308l.091.013a.391.391 0 0 1 .336.387v.336c0 .43.348.778.778.778h2.966c.401 0 .726.325.726.726v.447c0 .154-.123.28-.277.28a.282.282 0 0 0-.282.279v.615a.333.333 0 0 1-.332.335.337.337 0 0 0-.338.335v.503c0 .154-.123.28-.278.28a.281.281 0 0 0-.281.279v.056c0 .185-.15.335-.335.335h-.615a.277.277 0 0 1-.279-.277.281.281 0 0 0-.28-.282h-.503a.335.335 0 0 1-.335-.335v-.056a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.277.281.281 0 0 0-.279-.281h-1.229a.278.278 0 0 0-.28.277.281.281 0 0 1-.279.282h-1.174a.333.333 0 0 0-.335.332c0 .186-.15.338-.335.338h-1.174a.277.277 0 0 0-.279.277.28.28 0 0 1-.277.282.28.28 0 0 0-.282.277.281.281 0 0 1-.279.282h-.084a.305.305 0 0 1-.307-.305.31.31 0 0 1 .247-.303l.162-.033a.24.24 0 0 0 .186-.176.242.242 0 0 0-.233-.3h-.642a.277.277 0 0 0-.279.276.28.28 0 0 1-.277.282.28.28 0 0 0-.282.277.281.281 0 0 1-.279.282h-.112a.277.277 0 0 1-.279-.278.28.28 0 0 0-.278-.281.281.281 0 0 1-.281-.28v-.111a.278.278 0 0 0-.278-.28.28.28 0 0 1-.281-.277.28.28 0 0 0-.277-.281.28.28 0 1 1-.005-.559.28.28 0 0 0 .282-.277.281.281 0 0 0-.279-.282h-.112a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-.223a.056.056 0 0 1-.056-.055c0-.031.025-.056.056-.056h.335c.154 0 .279.122.279.277a.28.28 0 0 0 .559.004.28.28 0 0 1 .559-.004.28.28 0 0 0 .279.281h.056c.185 0 .335.15.335.336v.056c0 .154.123.279.278.279a.28.28 0 0 1 .281.277.28.28 0 0 0 .277.282.28.28 0 0 1 .282.277.28.28 0 0 0 .279.281h.671a.277.277 0 0 0 .279-.277.28.28 0 0 1 .277-.281.281.281 0 0 0 .282-.28v-.553c0-.166.117-.308.279-.34l.033-.007a.306.306 0 0 0 .247-.3c0-.169.137-.309.307-.309h.643c.154 0 .279.123.279.278a.28.28 0 0 0 .279.281h.661c.16 0 .289.13.289.29v.177c0 .102.098.176.197.149.388-.088.777-.068 1.172-.064l.253.002h.052a.558.558 0 0 0 .562-.557v-.22c0-.185.15-.336.335-.336h.056a.28.28 0 0 0 .002-.559.282.282 0 0 1-.282-.279V32.24a.278.278 0 0 0-.277-.28.281.281 0 0 1-.281-.279v-.032Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M194.97 47.663a.28.28 0 0 1 .279-.281h1.788c.154 0 .279.123.279.277a.28.28 0 0 0 .278.282.28.28 0 0 1 .281.279v.056c0 .185.15.335.336.335h3.52c.154 0 .279.123.279.278 0 .154.125.281.28.281h1.788c.154 0 .279.123.279.277 0 .155.125.282.28.282h1.899c.155 0 .28.123.28.277 0 .154.125.282.279.282h.056c.124 0 .224.098.224.221 0 .124-.1.226-.224.226h-12.014a1.397 1.397 0 0 1-1.397-1.397v-.783c0-.34.275-.614.615-.614h.335c.154 0 .28-.123.28-.278Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M202.572 22.515a.056.056 0 1 1 .112 0v2.011c0 .155.123.28.278.28a.281.281 0 0 0 .281-.28v-.279a.56.56 0 0 1 .559-.559h.252a.306.306 0 0 0 .307-.305.31.31 0 0 0-.247-.303l-.065-.013a.305.305 0 0 1-.247-.299c0-.17.137-.309.307-.309h.643c.154 0 .279.123.279.277 0 .155.125.282.28.282h1.732c.493 0 .894.4.894.894v.335c0 .309-.25.559-.559.559h-.223a.333.333 0 0 0-.336.333c0 .185-.15.337-.335.337h-1.173a.278.278 0 0 0-.28.278.281.281 0 0 1-.279.281h-.671a.277.277 0 0 0-.279.277c0 .155.125.282.279.282h1.509c.432 0 .782.35.782.782v.391a.391.391 0 0 1-.391.392h-.279a.111.111 0 0 0-.112.11c0 .062-.05.113-.112.113h-.782a.335.335 0 0 0-.335.335v.056c0 .155-.123.28-.278.28a.281.281 0 0 0-.281.28v3.348c0 .218.175.395.393.395.105 0 .231.03.263.13a1.1 1.1 0 0 1 .021.268.265.265 0 0 0 .266.273h.01c.153 0 .276.123.276.275a.283.283 0 0 1-.279.283h-.112a.277.277 0 0 1-.279-.277.28.28 0 0 0-.278-.282.28.28 0 0 1-.281-.277.281.281 0 0 0-.279-.281.286.286 0 0 1-.287-.276l-.097-3.578a.35.35 0 0 0-.281-.336.355.355 0 0 1-.286-.346v-1.108a.278.278 0 0 0-.277-.28.281.281 0 0 1-.281-.279v-1.9c0-.154.123-.28.277-.28a.281.281 0 0 0 .281-.279v-2.011Zm13.747-6.849c0-.136.11-.247.246-.247h1.263c.154 0 .279.123.279.277 0 .155.125.282.279.282h1.118c.154 0 .279.123.279.277 0 .154.126.282.28.282h.112c.154 0 .279.123.279.277a.28.28 0 0 0 .277.281c.155 0 .282.125.282.28v.111c0 .155.123.28.277.28a.28.28 0 1 1 .004.559.281.281 0 0 0-.281.279v.503a.333.333 0 0 1-.333.335.338.338 0 0 0-.338.335v.056c0 .155-.123.28-.277.28a.28.28 0 0 0-.282.277.28.28 0 0 1-.277.282.28.28 0 0 0-.281.277.28.28 0 0 1-.278.281.28.28 0 0 0-.281.28v.056c0 .185-.15.335-.335.335h-.894a1.23 1.23 0 0 1-1.23-1.23v-2.116a.229.229 0 0 0-.229-.23.231.231 0 0 1-.231-.216l-.059-.94a.596.596 0 0 1 .594-.633h.289a.306.306 0 0 0 .307-.304.31.31 0 0 0-.247-.304l-.115-.023a.244.244 0 0 1-.197-.239Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.375 41.18a.28.28 0 0 1 .559-.002c0 .155.125.282.279.282h.671c.154 0 .279.123.279.277a.28.28 0 0 0 .277.282c.155 0 .282.125.282.28v.111c0 .154.123.28.277.28a.28.28 0 0 1 .282.277.28.28 0 0 0 .277.281c.154 0 .281.125.281.28v.614c0 .185.151.336.336.336h.056c.154 0 .279.123.279.277a.28.28 0 0 0 .277.281.28.28 0 0 1 .282.278.28.28 0 0 0 .279.281h.335c.34 0 .615.27.615.61 0 .34.275.62.615.62h1.453a.28.28 0 0 1 .002.559.281.281 0 0 0-.282.279v1.788c0 .154-.123.28-.277.28a.28.28 0 0 0-.282.276.281.281 0 0 1-.279.282h-.67a.278.278 0 0 1-.28-.277.28.28 0 0 0-.277-.282.282.282 0 0 1-.282-.28v-.502a.333.333 0 0 0-.332-.335.337.337 0 0 1-.338-.336v-.28a.614.614 0 0 0-.614-.614h-.219a.348.348 0 0 1-.341-.28l-.014-.071a.256.256 0 0 0-.251-.207.26.26 0 0 1-.259-.235l-.065-.712c-.013-.149-.142-.254-.287-.217a.261.261 0 0 0-.197.223l-.082 1.23a.287.287 0 0 1-.286.27.29.29 0 0 1-.291-.29v-1.22a.278.278 0 0 0-.277-.279.282.282 0 0 1-.282-.28v-.502a.333.333 0 0 0-.332-.335.337.337 0 0 1-.338-.336v-1.285a.278.278 0 0 0-.278-.28.281.281 0 0 1-.281-.279v-1.117Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.375 18.047a.28.28 0 0 1 .279-.281h2.347c.154 0 .28.123.28.277a.28.28 0 0 0 .279.281h.112c.154 0 .279.123.279.278a.28.28 0 0 0 .277.281c.155 0 .282.125.282.28v.111c0 .155.123.28.277.28a.28.28 0 0 1 .282.277c0 .154.125.282.279.282h.056c.185 0 .335.15.335.335v.503c0 .154.125.28.28.28h.223c.031 0 .056.024.056.055 0 .03-.025.056-.056.056h-2.067a.333.333 0 0 1-.336-.333.337.337 0 0 0-.335-.338h-1.006a.335.335 0 0 0-.335.336v.055c0 .155-.123.28-.277.28a.281.281 0 0 0-.282.28v.782c0 .03-.024.055-.055.055a.057.057 0 0 1-.057-.055v-.839a.222.222 0 0 0-.221-.223c-.124 0-.226.1-.226.223v.056a.28.28 0 0 1-.279.28h-2.459a.277.277 0 0 1-.279-.278.281.281 0 0 0-.279-.281h-.046a.325.325 0 0 1-.324-.345l.073-1.173a.289.289 0 0 1 .288-.27h.009a.277.277 0 0 0 .279-.277c0-.155.125-.282.279-.282h2.906c.154 0 .279.123.279.277 0 .155.126.282.28.282h.67a.28.28 0 0 0 .002-.559.281.281 0 0 1-.281-.28v-.055a.335.335 0 0 0-.335-.336h-1.174a.277.277 0 0 1-.279-.277Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.24 43.53c0-.155.125-.282.279-.282h.559a.28.28 0 0 1 .002.559.282.282 0 0 0-.282.28v.67c0 .154-.123.28-.277.28a.28.28 0 0 0-.281.276.282.282 0 0 1-.28.282h-.112a.277.277 0 0 0-.279.277.281.281 0 0 1-.279.282h-.559a.278.278 0 0 0-.28.277.28.28 0 0 1-.277.282.281.281 0 0 0-.281.279v.056c0 .185.15.335.335.335h1.732c.154 0 .28.123.28.277a.282.282 0 0 1-.28.282h-5.364a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-1.788a.277.277 0 0 0-.279.277.282.282 0 0 1-.28.282h-.67a.278.278 0 0 1-.28-.277c0-.155.125-.282.28-.282h.558c.155 0 .28-.123.28-.277 0-.154.125-.282.279-.282h.615a.333.333 0 0 0 .335-.332c0-.186.15-.338.335-.338h1.16c.162 0 .293-.13.293-.292 0-.15.114-.279.264-.294l.629-.062a.319.319 0 0 0 .279-.24.324.324 0 0 1 .291-.245l1.168-.078a.356.356 0 0 0 .328-.286.362.362 0 0 1 .353-.291h.544a.277.277 0 0 0 .279-.278c0-.154.125-.281.28-.281h.67c.154 0 .28-.123.28-.278Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.949 45.873c0-.154.125-.281.28-.281h1.452c.34 0 .615.27.615.61 0 .34.275.62.615.62h1.453a.28.28 0 0 1 .002.559v-.001a.281.281 0 0 0-.282.28v1.787c0 .155-.123.28-.277.28a.28.28 0 0 0-.282.277.281.281 0 0 1-.279.282h-.67a.278.278 0 0 1-.28-.278.28.28 0 0 0-.277-.281.282.282 0 0 1-.282-.28v-.503a.333.333 0 0 0-.332-.335.337.337 0 0 1-.338-.335v-.615a.278.278 0 0 0-.278-.28.281.281 0 0 1-.281-.279v-.67a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.277Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.778 45.65a.198.198 0 0 1 .138-.058h.099c.164 0 .324.09.361.25.034.151.028.293.026.49l-.003.277a.207.207 0 0 0 .208.212h.035c.116 0 .216.082.239.196l.016.083c.033.163.176.28.341.28h.219c.339 0 .614.275.614.614v.28c0 .185.148.335.333.335.185 0 .337.15.337.335v.503c0 .155.123.28.278.28.154 0 .281.125.281.28v.223a.503.503 0 0 1-.503.503h-1.061a.222.222 0 0 1-.224-.222c0-.124-.1-.225-.223-.225h-.056a.278.278 0 0 1-.28-.278.281.281 0 0 0-.279-.281h-.671a.277.277 0 0 1-.279-.277.281.281 0 0 0-.279-.282h-1.23a.277.277 0 0 1-.279-.277.281.281 0 0 0-.279-.282h-.559a.278.278 0 0 1-.28-.277c0-.154.125-.282.28-.282h1.285c.123 0 .223.099.223.222 0 .124.101.226.224.226h.894c.309 0 .559-.25.559-.56v-.277a.28.28 0 0 0-.279-.281.283.283 0 0 1-.283-.278l-.004-.553-.003-.24c-.001-.176.003-.352.008-.528a.191.191 0 0 1 .056-.132Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M202.571 45.648c0-.031.024-.056.055-.056s.057.025.057.056v.614c0 .309.25.56.558.56h.28c.154 0 .279.122.279.276 0 .155.125.282.28.282h3.576c.154 0 .279.123.279.277 0 .155.125.282.28.282h1.229a.277.277 0 0 0 .279-.278.28.28 0 0 1 .278-.281c.154 0 .281.125.281.28v.279a.56.56 0 0 1-.559.559h-.894a.222.222 0 0 1-.223-.222c0-.124-.1-.226-.224-.226h-1.285a.277.277 0 0 0-.279.278.28.28 0 0 0 .279.281h.559c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-1.743a.325.325 0 0 1-.325-.325v-.154a.18.18 0 0 0-.191-.18c-.285.018-.571.035-.856.051l-.302.02-.288.016-.266.016h-.039c-.261-.004-.405-.276-.405-.538a.694.694 0 0 0-.69-.694h-1.321a.335.335 0 0 1-.335-.335v-.056c0-.154.123-.28.277-.28a.28.28 0 0 0 .281-.277c0-.154.125-.281.28-.281h.558a.28.28 0 0 0 .28-.28v-.223Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.663 46.766c0-.34.275-.615.614-.615h.28c.185 0 .335.148.335.333 0 .185.15.338.335.338h1.099c.142 0 .266.092.3.23a.317.317 0 0 0 .271.239c.107.01.213.02.32.032a.64.64 0 0 1 .581.637c0 .357.289.65.645.65h.752c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-1.788a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-2.347a.277.277 0 0 0-.279.277.282.282 0 0 1-.28.282h-.335a.615.615 0 0 1-.615-.615v-.28c0-.184.148-.334.333-.334.185 0 .338-.15.338-.336v-.838Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M216.207 14.804c0-.03.024-.056.055-.056s.056.025.056.056v.223c0 .155.126.28.28.28h1.341c.031 0 .056.024.056.055s-.025.057-.056.057h-1.307c-.159 0-.281.13-.242.285.022.088.095.175.183.197l.067.017a.312.312 0 0 1 .237.302c0 .174-.14.316-.314.316h-.582a.281.281 0 0 0-.277.328c.06.413.065.821.06 1.235a.22.22 0 0 0 .22.225c.122 0 .223.1.223.221v1.903c0 .802-.651 1.453-1.453 1.453h-1.397a.056.056 0 0 1-.056-.056c0-.03.025-.056.056-.056h.838a.223.223 0 0 0 .224-.222.226.226 0 0 0-.224-.225h-.056a.28.28 0 0 1-.279-.28v-.111a.278.278 0 0 0-.278-.28.281.281 0 0 1-.281-.28v-.442c0-.219.175-.395.393-.395.105 0 .231.029.265.128.015.042.018.1.023.214a869.347 869.347 0 0 0-.007.559.213.213 0 0 0 .213.216h.065c.153 0 .277.123.277.276a.28.28 0 0 0 .278.283.28.28 0 0 1 .281.277.28.28 0 0 0 .277.282.281.281 0 0 0 .282-.28v-2.905a.278.278 0 0 0-.277-.28.281.281 0 0 1-.282-.28v-.614a.335.335 0 0 0-.335-.335h-.056a.277.277 0 0 1-.279-.277.28.28 0 0 0-.278-.282.28.28 0 0 1-.281-.277.281.281 0 0 0-.28-.282h-.503a.333.333 0 0 1-.335-.332c0-.185.15-.338.335-.338h.615c.154 0 .28.123.28.277a.28.28 0 1 0 .558.004c0-.154.125-.281.28-.281h1.117a.28.28 0 0 0 .28-.28v-.223Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.36 28.718c0-.185.15-.335.335-.335h.559c.185 0 .335.15.335.335v.056c0 .154.123.28.277.28.154 0 .282.124.282.279v1.788c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.112a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.277.281.281 0 0 0-.279-.281h-.056a.335.335 0 0 0-.335.335v1.118c0 .185.15.335.335.335h.056c.154 0 .279.123.279.277 0 .155.125.282.28.282h.106c.147 0 .258.133.229.277a.235.235 0 0 0 .229.282h.022c.139 0 .252.112.252.251v1.37a.278.278 0 0 1-.278.279.281.281 0 0 1-.281-.28v-.112a.278.278 0 0 0-.277-.279.28.28 0 0 1-.282-.277.281.281 0 0 0-.279-.282h-.028a.307.307 0 0 1-.301-.247l-.012-.061a.381.381 0 0 0-.299-.3.386.386 0 0 1-.31-.377v-3.43c0-.154.123-.279.277-.279a.282.282 0 0 0 .282-.279v-.056Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.01 44.087c0-.154.123-.28.277-.28.155 0 .282.126.282.28v.67c0 .155-.123.28-.277.28a.28.28 0 0 0-.282.277.28.28 0 0 1-.277.282.281.281 0 0 0-.282.28v.558a.28.28 0 0 1-.559.002.281.281 0 0 0-.279-.282h-.615a.333.333 0 0 0-.335.333c0 .185-.15.338-.335.338h-4.414a.61.61 0 0 1-.615-.61c0-.34.275-.62.614-.62h6.091a.334.334 0 0 0 .336-.332c0-.185.147-.338.332-.338.185 0 .338-.15.338-.335v-.503Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M206.815 40.621c0-.154.123-.28.277-.28.155 0 .282.126.282.28v1.677c0 .154.123.279.277.279.154 0 .282.125.282.28v1.285c0 .185.147.335.332.335.186 0 .338.15.338.335v.503c0 .154.123.28.277.28a.28.28 0 0 1 .282.279v1.23c0 .153.123.279.277.279a.28.28 0 0 1 .282.277.281.281 0 0 1-.28.281h-1.229a.277.277 0 0 1-.279-.277.281.281 0 0 0-.28-.282h-1.229a.277.277 0 0 1-.279-.277.28.28 0 0 1 .279-.281h.084c.17 0 .307-.136.307-.305a.31.31 0 0 1 .247-.303l.032-.007a.348.348 0 0 0 .28-.34v-2.9a.278.278 0 0 0-.277-.28.281.281 0 0 1-.282-.28v-1.788Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.008 33.3c0-.246.2-.447.447-.447h1.174c.401 0 .726.326.726.727v.447c0 .154-.123.28-.277.28a.281.281 0 0 0-.282.279v.614a.333.333 0 0 1-.332.336.337.337 0 0 0-.338.335v.503c0 .154-.123.28-.278.28a.281.281 0 0 0-.281.279v.111c0 .155-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.67a.278.278 0 0 0-.277-.28.282.282 0 0 1-.282-.279v-.112a.28.28 0 0 0-.279-.28h-.056a.222.222 0 0 1-.223-.22c0-.124.1-.226.223-.226h.056a.28.28 0 0 0 .279-.28v-.67c0-.154.123-.28.278-.28a.281.281 0 0 0 .281-.279V33.3Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M202.572 22.515a.056.056 0 1 1 .112 0v2.011c0 .155.123.28.278.28a.281.281 0 0 0 .281-.28v-.279a.56.56 0 0 1 .559-.559h.252a.306.306 0 0 0 .307-.305.31.31 0 0 0-.247-.303l-.065-.013a.305.305 0 0 1-.247-.299c0-.17.137-.309.307-.309h.643c.154 0 .279.123.279.277 0 .155.125.282.28.282h2.291c.185 0 .335.147.335.332 0 .186-.15.338-.335.338h-2.85a.278.278 0 0 0-.28.278c0 .154.125.281.28.281h1.117c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-1.173a.333.333 0 0 0-.335.333.338.338 0 0 1-.336.337h-.503a.277.277 0 0 0-.279.278.281.281 0 0 1-.279.281h-.056a.336.336 0 0 1-.336-.335v-.559a.222.222 0 0 0-.221-.223c-.124 0-.226.1-.226.223v1.732c0 .155.123.28.278.28.154 0 .281.125.281.28v1.452c0 .03-.024.056-.055.056a.057.057 0 0 1-.057-.056v-1.341a.278.278 0 0 0-.277-.28.281.281 0 0 1-.281-.279v-1.9c0-.154.123-.28.277-.28a.281.281 0 0 0 .281-.279v-2.011Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.725 15.03c0-.155.125-.282.279-.282h5.923c.154 0 .28.123.28.277a.282.282 0 0 1-.28.282h-1.117a.278.278 0 0 0-.28.277.28.28 0 0 1-.559.004.281.281 0 0 0-.279-.281h-.615a.333.333 0 0 0-.335.333c0 .185.15.337.335.337h.503c.155 0 .28.123.28.278a.28.28 0 0 0 .279.281h.028c.146 0 .272.104.301.247l.022.11a.321.321 0 0 0 .239.252.327.327 0 0 1 .248.316v.584a.28.28 0 0 1-.559.002.28.28 0 0 0-.277-.282.281.281 0 0 1-.281-.279v-.112a.278.278 0 0 0-.278-.279.28.28 0 0 1-.281-.277.281.281 0 0 0-.28-.282h-.041a.303.303 0 0 1-.295-.23.308.308 0 0 0-.277-.232L211.277 16a.344.344 0 0 1-.323-.343.348.348 0 0 0-.346-.35h-.604a.277.277 0 0 1-.279-.276Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.932 34.363c0-.03.025-.056.056-.056h.335c.154 0 .279.123.279.277a.28.28 0 0 0 .559.004.28.28 0 0 1 .559-.004.28.28 0 0 0 .279.281h.056c.185 0 .335.15.335.336v.056c0 .154.123.279.278.279a.28.28 0 0 1 .281.277.28.28 0 0 0 .277.282.28.28 0 0 1 .282.277c0 .154.125.282.279.282h.671a.277.277 0 0 0 .279-.278.28.28 0 0 1 .559-.004c0 .154.125.282.279.282h1.453c.031 0 .056.024.056.055 0 .03-.025.056-.056.056h-1.453a.277.277 0 0 0-.279.278.28.28 0 0 1-.277.281.28.28 0 0 0-.282.277.281.281 0 0 1-.279.282h-.084a.305.305 0 0 1-.307-.305.31.31 0 0 1 .246-.303l.163-.033a.24.24 0 0 0 .186-.176.242.242 0 0 0-.233-.3h-.642a.277.277 0 0 0-.279.277.28.28 0 0 1-.277.281.28.28 0 0 0-.282.277.281.281 0 0 1-.279.282h-.112a.277.277 0 0 1-.279-.277.28.28 0 0 0-.278-.282.281.281 0 0 1-.281-.28v-.111a.278.278 0 0 0-.278-.28.28.28 0 0 1-.281-.277.28.28 0 0 0-.277-.281.28.28 0 1 1-.005-.559.28.28 0 0 0 .282-.277.281.281 0 0 0-.279-.282h-.112a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-.223a.056.056 0 0 1-.056-.055Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.742 38.165c0-.154.125-.281.28-.281h5.029a.61.61 0 0 1 .614.61c0 .34-.275.62-.614.62h-4.415a.335.335 0 0 1-.335-.336v-.056a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.277Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M194.858 47.107c0-.155.125-.282.279-.282h4.247c.154 0 .279.123.279.277 0 .155.125.282.28.282h.559a.28.28 0 0 0 .279-.28v-.223c0-.03.025-.056.055-.056.031 0 .057.025.057.056v.224a.28.28 0 0 0 .279.279h1.788c.154 0 .28.123.28.277a.282.282 0 0 1-.28.282h-5.364a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-1.788a.277.277 0 0 0-.279.277.282.282 0 0 1-.28.282h-.67a.278.278 0 0 1-.28-.277c0-.155.125-.282.28-.282h.558c.155 0 .28-.123.28-.277Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M217.432 47.384c0-.309.25-.559.559-.559h.111c.309 0 .559.25.559.559v.224a.333.333 0 0 1-.333.335.337.337 0 0 0-.337.335v.28c0 .339.275.614.614.614h.336a.277.277 0 0 0 .279-.277c0-.155.125-.282.279-.282h2.347c.155 0 .28.123.28.278a.281.281 0 0 1-.28.281h-.559a.277.277 0 0 0-.279.277.281.281 0 0 1-.279.282h-2.962a.894.894 0 0 1-.894-.894v-.615c0-.154.123-.28.277-.28a.281.281 0 0 0 .282-.279v-.279Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.858 34.616c0-.17.137-.31.307-.31h.643c.154 0 .279.124.279.278a.28.28 0 0 0 .279.281h.661c.16 0 .289.13.289.29v.177c0 .102.098.176.197.149.387-.088.777-.068 1.172-.064a244.264 244.264 0 0 1 .305.002.557.557 0 0 0 .561-.556v-.5a.056.056 0 0 1 .112 0v.558c0 .34-.275.615-.615.615h-.894a.277.277 0 0 0-.279.277.281.281 0 0 1-.279.282h-1.23a.277.277 0 0 0-.279.277.281.281 0 0 1-.279.282h-.615a.894.894 0 0 1-.894-.895v-.497c0-.166.117-.308.279-.34l.033-.007a.306.306 0 0 0 .247-.3Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.682 18.605c0-.155.123-.28.278-.28.154 0 .281.125.281.28v.67c0 .154.123.28.278.28a.28.28 0 0 1 .281.279v1.117c0 .155.123.28.277.28.155 0 .282.125.282.28v2.458c0 .154-.123.28-.277.28a.281.281 0 0 1-.282-.28v-1.23a.278.278 0 0 0-.277-.279.281.281 0 0 1-.282-.28v-.67a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.276.281.281 0 0 0-.279-.282h-.67a.28.28 0 0 1-.003-.559.28.28 0 0 0 .282-.277.28.28 0 0 1 .279-.281h.056c.185 0 .335-.15.335-.336v-.614Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.375 18.047a.28.28 0 0 1 .279-.281h2.347c.155 0 .28.123.28.277a.28.28 0 0 0 .279.281h.112c.154 0 .279.123.279.278a.28.28 0 0 0 .278.281c.154 0 .281.125.281.28v.111c0 .155.123.28.277.28a.28.28 0 0 1 .282.277c0 .154.125.282.279.282h.056c.185 0 .335.15.335.335v.503c0 .154.125.28.28.28h.223c.031 0 .056.024.056.055 0 .03-.025.056-.056.056h-2.067a.336.336 0 0 1-.336-.335v-.28a.056.056 0 1 1 .112 0v.224c0 .154.125.28.28.28h.558a.28.28 0 0 0 .002-.559.28.28 0 0 1-.281-.278.28.28 0 0 0-.277-.281.28.28 0 0 1-.282-.278.281.281 0 0 0-.279-.281h-.671a.277.277 0 0 1-.279-.278.28.28 0 0 0-.277-.281.281.281 0 0 1-.282-.28v-.055a.335.335 0 0 0-.335-.336h-1.174a.277.277 0 0 1-.279-.277Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.72 47.663a.28.28 0 0 1 .277-.281c.155 0 .282.125.282.28v.279c0 .308-.25.558-.559.558h-.894a.222.222 0 0 1-.223-.221c0-.124-.1-.226-.224-.226h-1.285a.277.277 0 0 0-.279.278.28.28 0 0 0 .279.281h.559c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-1.743a.325.325 0 0 1-.325-.325v-.154a.18.18 0 0 0-.191-.18c-.286.018-.571.035-.857.051l-.301.02-.288.016-.266.016a.745.745 0 0 1-.25-.025c-.124-.042-.194-.17-.194-.301 0-.19.155-.347.346-.347h5.857a.277.277 0 0 0 .279-.278Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.061 32.077c0-.432.35-.788.782-.788h1.564c.432 0 .783.344.783.776a.788.788 0 0 1-.783.789h-1.564a.777.777 0 0 1-.782-.777Z",
    fill: "#080505"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.061 30.513c0-.432.35-.788.782-.788h1.564c.432 0 .783.344.783.776a.788.788 0 0 1-.783.788h-1.564a.777.777 0 0 1-.782-.776Z",
    fill: "#C57415"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.883 30.513c0-.432.35-.788.782-.788h1.565c.432 0 .782.344.782.776 0 .432-.35.788-.782.788h-1.565a.777.777 0 0 1-.782-.776Z",
    fill: "#C0751D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.883 28.945c0-.432.35-.788.782-.788h1.565c.432 0 .782.345.782.777 0 .432-.35.788-.782.788h-1.565a.777.777 0 0 1-.782-.777Z",
    fill: "#5B3911"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.061 28.945c0-.432.35-.788.782-.788h1.564c.432 0 .783.345.783.777a.788.788 0 0 1-.783.788h-1.564a.777.777 0 0 1-.782-.777Z",
    fill: "#5B3910"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.013 18.66c0-.185.148-.335.333-.335.185 0 .337.15.337.335v.56c0 .184-.15.335-.335.335h-.056a.277.277 0 0 0-.279.277.28.28 0 0 1-.277.281.28.28 0 0 0-.282.278c0 .154.125.281.28.281h.67c.154 0 .279.123.279.277a.28.28 0 0 0 .278.282c.154 0 .281.125.281.28v.614a.333.333 0 0 1-.333.335.337.337 0 0 1-.337-.335v-.204a.54.54 0 0 0-.578-.537l-.766.055a.303.303 0 0 0-.274.229.308.308 0 0 1-.298.233h-.655a.335.335 0 0 1-.335-.335v-.056c0-.154.123-.28.277-.28a.28.28 0 0 0 .282-.276.28.28 0 0 1 .277-.282.28.28 0 0 0 .282-.277.28.28 0 0 1 .277-.282.281.281 0 0 0 .281-.28v-.055c0-.185.148-.335.333-.335.185 0 .338-.15.338-.335v-.448Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.025 34.586c0-.154.123-.28.278-.28.154 0 .281.126.281.28v7.711c0 .155-.123.28-.277.28a.282.282 0 0 1-.282-.28v-7.711Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.087 17.443c0-.19.152-.345.343-.345.131 0 .258.072.295.198.05.171.043.323.039.542l-.003.277a.209.209 0 0 0 .209.212h.013c.122 0 .222.1.222.221v1.902c0 .803-.651 1.453-1.453 1.453h-1.397a.056.056 0 0 1-.056-.055c0-.031.025-.056.056-.056h.838a.222.222 0 0 0 .223-.222c0-.124-.1-.226-.223-.226h-.056a.28.28 0 0 1-.279-.279v-.112a.278.278 0 0 0-.278-.28.281.281 0 0 1-.281-.278v-.444c0-.218.175-.395.393-.395.105 0 .231.03.265.128.015.043.018.1.023.215a869.347 869.347 0 0 0-.007.559.213.213 0 0 0 .212.216h.066c.153 0 .277.123.277.276a.28.28 0 0 0 .277.283.28.28 0 0 1 .282.277.28.28 0 0 0 .277.281.281.281 0 0 0 .282-.279v-2.906a.278.278 0 0 0-.278-.279.281.281 0 0 1-.281-.28v-.604Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.057 46.203a.614.614 0 0 1 .616-.611c.339 0 .621.27.621.61 0 .34.275.62.615.62h1.453a.28.28 0 0 1 .002.559v-.001a.28.28 0 0 0-.282.277.28.28 0 0 1-.277.282.281.281 0 0 0-.281.28v.055a.333.333 0 0 1-.333.335.338.338 0 0 1-.338-.335v-.056a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.277.281.281 0 0 0-.279-.281.28.28 0 0 1-.28-.276v-.01c0-.15-.123-.27-.272-.266a9.956 9.956 0 0 1-.118-.003c-.203-.008-.286-.228-.288-.432v-.19Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.36 28.718c0-.185.15-.335.335-.335h.559c.185 0 .335.15.335.335v.056c0 .154.123.28.277.28.154 0 .282.124.282.279v1.788c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.112a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.277.281.281 0 0 0-.279-.281h-.391a.559.559 0 0 1-.559-.559v-.28c0-.154.123-.279.277-.279a.282.282 0 0 0 .282-.279v-.056Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.163 21.007c0-.185.15-.335.335-.335h.994c.192 0 .347.153.347.345a.35.35 0 0 1-.322.349l-.488.034a.872.872 0 0 0-.808.808l-.038.537a.359.359 0 0 1-.287.327.363.363 0 0 0-.292.354v1.437c0 .34-.275.614-.614.614h-.559a.056.056 0 0 1-.056-.055c0-.03.025-.056.056-.056h.223a.28.28 0 0 0 .28-.28v-2.29c0-.186.147-.336.333-.336.185 0 .337-.15.337-.335v-.503c0-.154.123-.28.278-.28a.281.281 0 0 0 .281-.279v-.056Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.238 28.716c0-.309.25-.559.559-.559h.112c.247 0 .447.2.447.447v.168c0 .154-.123.28-.277.28a.281.281 0 0 0-.282.279v3.348c0 .219.175.396.393.396.105 0 .231.03.263.129.016.05.018.121.022.269a.265.265 0 0 0 .265.272h.011c.152 0 .275.123.275.276a.283.283 0 0 1-.279.283h-.112a.277.277 0 0 1-.279-.277.28.28 0 0 0-.277-.282.28.28 0 0 1-.282-.277.28.28 0 0 0-.277-.282.281.281 0 0 1-.282-.28v-4.19Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M206.818 25.143c0-.185.15-.337.335-.337h.503a.28.28 0 0 1 .002.559.28.28 0 0 0-.281.279v.35a.63.63 0 0 1-.598.63l-.687.033-.365.019a9.586 9.586 0 0 1-1.672-.045.291.291 0 0 1-.254-.292c0-.167.135-.304.302-.304h.648a.277.277 0 0 0 .279-.277c0-.155.125-.282.28-.282h1.173a.333.333 0 0 0 .335-.332Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M200.837 44.709a.308.308 0 0 1 .297-.233h.6c.154 0 .279.123.279.277a.281.281 0 0 1-.279.281h-.559a.278.278 0 0 0-.28.278.281.281 0 0 1-.279.281h-1.173a.333.333 0 0 0-.336.333c0 .185-.15.338-.335.338h-.615a.277.277 0 0 0-.279.277.281.281 0 0 1-.279.282h-1.174a.333.333 0 0 1-.335-.333c0-.185.15-.338.335-.338h1.16c.162 0 .293-.13.293-.291 0-.15.114-.28.264-.294l.628-.063a.32.32 0 0 0 .28-.24.324.324 0 0 1 .291-.245l1.221-.082a.303.303 0 0 0 .275-.228Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M223.566 31.615a.231.231 0 0 1 .23-.215c.128 0 .234.104.234.233v4.685a.333.333 0 0 1-.333.335.338.338 0 0 1-.338-.335V32.91c0-.032.026-.058.058-.058.03 0 .056-.023.058-.053l.091-1.185Z",
    fill: "#090909"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 30.505c0-.185.151-.335.336-.335h.056c.154 0 .279.123.279.277a.28.28 0 0 0 .277.282c.155 0 .282.125.282.28v.11c0 .155.123.28.277.28.154 0 .282.125.282.28v1.117a.28.28 0 0 1-.28.28h-.034a.244.244 0 0 1-.245-.244.248.248 0 0 0-.198-.243l-.114-.023a.305.305 0 0 1-.247-.299.31.31 0 0 0-.307-.309h-.028a.336.336 0 0 1-.336-.335v-1.118Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.68 17.45c-.016-.176.124-.321.297-.287.124.025.23.137.23.263v.035c0 .17.138.307.307.307h.028c.186 0 .336.15.336.335v2.291c0 .155-.123.28-.278.28a.281.281 0 0 0-.281.28v.279c0 .308.25.558.559.558h1.636a.052.052 0 0 0 .05-.038c.015-.06.102-.05.102.012v.077a.062.062 0 0 1-.061.061h-1.168a1.23 1.23 0 0 1-1.23-1.23v-2.112a.232.232 0 0 0-.232-.234.235.235 0 0 1-.234-.213l-.061-.664Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.678 49.46a.264.264 0 0 1 .262-.291c.146 0 .267.119.267.265v.014c0 .155.125.28.28.28h3.688c.154 0 .279.123.279.277a.281.281 0 0 1-.279.281h-3.909a.558.558 0 0 1-.556-.503 31.72 31.72 0 0 1-.032-.322Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.775 36.916a.29.29 0 0 1 .289-.266c.161 0 .294.131.294.293v.657c0 .155-.123.28-.277.28a.281.281 0 0 0-.282.28v2.955a.278.278 0 0 1-.332.275.282.282 0 0 1-.227-.275v-3.002c0-.129.103-.233.232-.233a.236.236 0 0 0 .235-.213l.068-.751Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M219.784 35.398c0-.061.087-.073.101-.013.006.023.027.04.051.04h.204c.174 0 .314.14.314.313v.078c0 .154.123.28.277.28a.28.28 0 0 1 .282.279v.614c0 .185-.15.336-.335.336h-.056a.278.278 0 0 1-.28-.278.281.281 0 0 0-.279-.281h-.503a.335.335 0 0 1-.335-.336v-.056a.278.278 0 0 0-.277-.279.28.28 0 0 1-.282-.277c0-.154.125-.282.279-.282h.777a.062.062 0 0 0 .062-.06v-.078Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.855 46.433c0-.154.126-.282.28-.282h4.135c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-4.135a.278.278 0 0 1-.28-.277Zm-4.134-26.599a.28.28 0 0 1 .279-.281h.671c.154 0 .279.123.279.277a.28.28 0 0 0 .278.282.28.28 0 0 1 .281.277.28.28 0 0 0 .277.281.28.28 0 0 1 .282.278.281.281 0 0 1-.28.281h-.558a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-1.229a.28.28 0 0 1-.003-.559.28.28 0 0 0 .282-.277Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.932 34.363c0-.03.025-.056.056-.056h.335c.154 0 .279.123.279.277a.28.28 0 0 0 .559.004.28.28 0 0 1 .559-.004.28.28 0 0 0 .279.281h.056c.185 0 .335.148.335.333 0 .185-.15.338-.335.338h-.056a.28.28 0 0 0-.002.559.28.28 0 0 1 .282.277.282.282 0 0 1-.28.282h-.559a.277.277 0 0 1-.279-.278.28.28 0 0 0-.277-.281.28.28 0 1 1-.005-.559.28.28 0 0 0 .282-.277.281.281 0 0 0-.279-.282h-.112a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-.223a.056.056 0 0 1-.056-.055Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.013 44.087c0-.154.123-.28.277-.28.155 0 .282.126.282.28v.67c0 .155-.123.28-.278.28a.28.28 0 0 0-.281.277.28.28 0 0 1-.277.282.281.281 0 0 0-.282.28v.558a.28.28 0 0 1-.559.002.281.281 0 0 0-.279-.282h-.671a.277.277 0 0 1-.279-.277.28.28 0 0 1 .279-.281h1.062a.333.333 0 0 0 .335-.333c0-.185.148-.338.333-.338.185 0 .338-.15.338-.335v-.503Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M220.454 20.962c0-.16.129-.29.288-.29h.662c.154 0 .279.123.279.277a.28.28 0 0 0 .278.282c.154 0 .281.125.281.28v.614a.333.333 0 0 1-.333.335.337.337 0 0 1-.337-.335v-.204a.54.54 0 0 0-.578-.537l-.766.054a.303.303 0 0 0-.274.23.308.308 0 0 1-.298.233h-.702a.286.286 0 0 1-.288-.286.29.29 0 0 1 .271-.29l1.246-.077a.287.287 0 0 0 .271-.286Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.742 38.165c0-.154.125-.281.28-.281h.558c.155 0 .28.123.28.277 0 .154.125.282.279.282h.112c.154 0 .279.123.279.277 0 .154.125.281.28.281h2.905c.155 0 .28-.123.28-.277a.28.28 0 0 1 .277-.281.282.282 0 0 0 .282-.28v-.223c0-.031.024-.056.055-.056s.056.025.056.056v.559a.614.614 0 0 1-.614.614h-4.415a.335.335 0 0 1-.335-.335v-.056a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.277Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.243 43.807c0-.309.25-.559.558-.559h.28a.28.28 0 0 1 .002.559.282.282 0 0 0-.282.28v.67c0 .154-.123.28-.277.28a.28.28 0 0 0-.281.276.282.282 0 0 1-.28.282h-.112a.28.28 0 0 1-.279-.28v-.055a.222.222 0 0 0-.222-.224.225.225 0 0 1-.225-.223v-.056a.28.28 0 0 1 .279-.28h.28a.56.56 0 0 0 .559-.558v-.112Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.375 41.18c0-.154.123-.279.277-.279.155 0 .282.125.282.28v.559c0 .154.123.279.277.279.154 0 .282.125.282.28v1.9a.278.278 0 0 1-.278.279.281.281 0 0 1-.281-.28v-1.34a.278.278 0 0 0-.278-.28.281.281 0 0 1-.281-.28v-1.117Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 39.393c0-.154.126-.282.28-.282h3.576c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-3.576a.278.278 0 0 1-.28-.277Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.663 46.766c0-.34.275-.615.614-.615h.28c.185 0 .335.15.335.336v.279c0 .03-.025.056-.055.056a.057.057 0 0 1-.057-.056v-.224a.278.278 0 0 0-.277-.279.281.281 0 0 0-.281.28v1.676c0 .154-.123.28-.278.28a.281.281 0 0 0-.281.279v.056a.333.333 0 0 1-.333.335.338.338 0 0 1-.338-.335v-.56c0-.184.148-.334.333-.334.185 0 .338-.15.338-.336v-.838Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.797 24.528c0-.154.123-.279.277-.279.155 0 .282.125.282.28v.95a1.23 1.23 0 0 1-1.229 1.229h-6.985a.056.056 0 0 1-.056-.056c0-.03.025-.056.056-.056h6.482c.648 0 1.173-.525 1.173-1.174v-.894Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M208.605 28.437a.28.28 0 0 1 .28-.28h.167c.062 0 .112.05.112.111 0 .062.05.113.112.113h.056c.092 0 .168.075.168.167v1.733a.444.444 0 0 1-.444.447.45.45 0 0 1-.451-.447v-1.844Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 21.01c0-.186.151-.338.336-.338h.056c.154 0 .279.123.279.277 0 .154.125.282.279.282h2.347c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-2.403a.222.222 0 0 1-.223-.222c0-.124-.1-.226-.224-.226h-.111a.334.334 0 0 1-.336-.332Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M208.605 42.965c0-.154.123-.28.278-.28.154 0 .281.126.281.28v.559c0 .154.123.28.278.28a.28.28 0 0 1 .281.279v1.229c0 .154-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.67a.278.278 0 0 0-.277-.28.282.282 0 0 1-.282-.28v-1.117Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.086 18.605c0-.155.123-.28.277-.28.155 0 .282.125.282.28v2.905c0 .155-.123.28-.278.28a.281.281 0 0 1-.281-.28v-2.905Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 32.24a.28.28 0 0 1 .28-.28h.112c.154 0 .279.123.279.277 0 .155.125.282.279.282h.107c.147 0 .258.133.229.277a.235.235 0 0 0 .229.282h.022c.139 0 .252.112.252.251v1.369c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-1.124a.384.384 0 0 0-.385-.385h-.065a.292.292 0 0 1-.283-.212 1.092 1.092 0 0 1-.028-.132c-.021-.157-.094-.326-.253-.326a.216.216 0 0 1-.216-.214v-.066Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 41.74c0-.155.125-.282.28-.282h.034c.144 0 .269.098.304.238l.003.009c.03.122.128.216.252.24l.11.022a.307.307 0 0 1 .246.302v.027c0 .154.123.28.278.28a.28.28 0 0 1 .281.277.28.28 0 0 0 .278.281c.154 0 .281.126.281.28v.67c0 .155-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.503a.335.335 0 0 0-.335-.335h-.056a.277.277 0 0 1-.279-.277.28.28 0 0 0-.278-.282.28.28 0 0 1-.281-.279v-.112a.278.278 0 0 0-.277-.28.28.28 0 0 1-.282-.276Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.061 30.513c0-.432.35-.788.782-.788h1.564c.432 0 .783.344.783.776a.788.788 0 0 1-.783.788h-1.564a.777.777 0 0 1-.782-.776Zm1.187-.628-.245.014a3.016 3.016 0 0 0-.305 0c-.277.026-.433.33-.428.608l-.001.244c-.008.237.254.323.491.325h.559a587.671 587.671 0 0 0 .739-.005l.293-.001a.615.615 0 0 0 .615-.615.61.61 0 0 0-.614-.615 25.85 25.85 0 0 0-1.104.045Z",
    fill: "#B5762D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.477 34.553a.306.306 0 0 1 .301-.246h.027c.155 0 .28.123.28.277a.28.28 0 0 0 .279.281h.615c.185 0 .335.148.335.333 0 .185-.15.338-.335.338h-.615a.277.277 0 0 1-.279-.277.28.28 0 1 0-.559-.004.281.281 0 0 1-.279.281h-.084a.306.306 0 0 1-.308-.305.31.31 0 0 1 .247-.303l.062-.012a.383.383 0 0 0 .3-.301l.013-.062Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M217.436 17.485a.28.28 0 0 1 .558-.002c0 .155.125.282.28.282h.056c.185 0 .335.15.335.335v.224c0 .308-.25.558-.559.558h-.056a.614.614 0 0 1-.614-.614v-.783Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M220.45 48.894c0-.154.125-.282.279-.282h1.118c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-.559a.277.277 0 0 0-.279.277.281.281 0 0 1-.28.282h-.67a.278.278 0 0 1-.28-.277c0-.155.125-.282.28-.282h.111c.155 0 .28-.123.28-.277Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.584 29.333c0-.154.123-.28.277-.28.155 0 .282.126.282.28v1.788c0 .155-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.111a.278.278 0 0 0-.277-.28.28.28 0 1 1-.004-.559.281.281 0 0 0 .281-.28v-.558Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.791 21.622c0-.154.123-.28.277-.28.155 0 .282.126.282.28v2.347c0 .154-.123.28-.277.28a.281.281 0 0 1-.282-.28v-2.347Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.76 18.549c0-.124.098-.224.222-.224.123 0 .225.1.225.224v3.129a.222.222 0 0 1-.222.223.225.225 0 0 1-.225-.223v-3.13Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M224.584 48.836c0-.185.15-.338.335-.338h1.677c.185 0 .335.148.335.333 0 .185-.15.338-.335.338h-1.677a.333.333 0 0 1-.335-.333Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.377 28.27c0-.062.05-.113.112-.113h.168a.28.28 0 0 1 .279.28v.667c0 .331-.281.59-.61.557a.563.563 0 0 1-.508-.557v-.444a.28.28 0 0 1 .28-.28h.167a.11.11 0 0 0 .112-.11Z",
    fill: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M206.484 28.548a.39.39 0 0 1 .392-.39h.391a.11.11 0 0 1 .111.11c0 .062-.05.113-.111.113h-.168a.28.28 0 0 0-.279.28v10.28a.056.056 0 0 1-.056.057.056.056 0 0 1-.056-.056v-9.89a.111.111 0 0 0-.111-.113.113.113 0 0 1-.113-.111v-.28Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M194.858 47.107c0-.155.125-.282.279-.282h.671c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-.559a.277.277 0 0 0-.279.277.282.282 0 0 1-.28.282h-.67a.278.278 0 0 1-.28-.277c0-.155.125-.282.28-.282h.558c.155 0 .28-.123.28-.277Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.588 36.93c0-.154.123-.28.277-.28.154 0 .282.126.282.28v1.9c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-1.9Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M224.584 49.45a.28.28 0 0 1 .279-.281h1.788c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-1.788a.277.277 0 0 1-.279-.278Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.01 49.45a.28.28 0 0 1 .279-.281h1.788c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-1.788a.277.277 0 0 1-.279-.278Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.566 41.737c0-.154.123-.279.278-.279.154 0 .281.125.281.28v1.788a.277.277 0 0 1-.277.279.282.282 0 0 1-.282-.28v-1.788Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.24 24.528c0-.154.123-.279.278-.279.154 0 .281.125.281.28v1.788a.277.277 0 0 1-.277.279.281.281 0 0 1-.282-.28v-1.788Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M219.217 18.045c0-.154.123-.28.277-.28.154 0 .282.126.282.28v1.788c0 .154-.123.28-.278.28a.28.28 0 0 1-.281-.28v-1.788Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.725 50.064c0-.185.15-.336.335-.336h.615c.154 0 .279.123.279.278a.28.28 0 0 0 .279.281h.056c.124 0 .224.099.224.222 0 .124-.1.225-.224.225h-.838a.167.167 0 0 1-.168-.166.169.169 0 0 0-.167-.169h-.112a.28.28 0 0 1-.279-.28v-.055Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.712 36.358a.294.294 0 0 1 .292-.264h.014c.155 0 .28.123.28.277 0 .154.125.282.279.282h1.453c.031 0 .056.024.056.055 0 .03-.025.056-.056.056h-1.453a.277.277 0 0 0-.279.278.28.28 0 0 1-.278.281.28.28 0 0 0-.281.277.281.281 0 0 1-.279.282h-.085a.306.306 0 0 1-.307-.305.31.31 0 0 1 .247-.303l.047-.01a.365.365 0 0 0 .292-.322l.058-.584Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.723 47.663a.28.28 0 0 1 .278-.281c.154 0 .281.125.281.28v.279c0 .308-.25.558-.559.558h-.888a.278.278 0 0 1-.274-.222.281.281 0 0 1 .274-.336h.609a.277.277 0 0 0 .279-.278Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.375 40.538c0-.17.135-.307.305-.307a.31.31 0 0 1 .303.246l.007.033c.032.162.175.28.34.28h.498c.185 0 .335.147.335.332 0 .185-.15.338-.335.338h-.615a.277.277 0 0 1-.279-.278.28.28 0 0 0-.278-.281.281.281 0 0 1-.281-.28v-.084Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.907 44.355a.28.28 0 0 1 .273.28c0 .156.127.286.283.286h.439c.219 0 .395.175.395.393 0 .105-.029.23-.128.265-.046.015-.11.018-.239.024l-.31-.004-.311-.003a.245.245 0 0 1-.241-.245v-.036a.28.28 0 0 0-.28-.282.28.28 0 0 1-.282-.276l.001-.12c.001-.105.031-.227.131-.26.05-.016.121-.018.269-.022Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.775 28.211a.057.057 0 0 1 .057-.054c.032 0 .058.026.058.058v1.507c0 .864.701 1.564 1.565 1.564h.279c.71 0 1.286-.575 1.286-1.285v-1.23c0-.03.024-.055.055-.055s.056.025.056.056v1.292c0 .74-.595 1.341-1.334 1.346h-.134l-.499.005c-.239.003-.478.004-.717.005l-.437.004c-.294-.022-.336-.025-.483-.167a.115.115 0 0 1-.001-.165.117.117 0 0 0 .034-.07c.023-.201.04-.403.055-.606l.029-.396.03-.417.031-.418.07-.974Z",
    fill: "#130101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.666 45.873a.28.28 0 0 1 .279-.281h.839c.308 0 .558.25.558.559v.335a.222.222 0 0 1-.221.223.225.225 0 0 1-.226-.223v-.056a.28.28 0 0 0-.279-.28h-.671a.277.277 0 0 1-.279-.277Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.76 28.43c0-.15.12-.273.271-.273.156 0 .282.13.275.285l-.09 2.067a.226.226 0 0 1-.226.219.23.23 0 0 1-.23-.229v-2.068Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 19.776c0-.494.401-.894.894-.894h3.074c.154 0 .279.123.279.277 0 .154.125.282.28.282h.782c.031 0 .056.024.056.055 0 .03-.025.056-.056.056h-.894a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.281h-2.906a.277.277 0 0 0-.279.277.28.28 0 0 1-.277.281.281.281 0 0 0-.282.28v.782c0 .03-.024.056-.055.056a.057.057 0 0 1-.057-.056v-.838Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M219.784 20.397c0-.155.125-.282.279-.282h.014c.151 0 .277.114.292.264l.03.303c.032.315-.176.61-.49.642-.217.023-.433.03-.663.028l-.331-.003-.193-.004a.056.056 0 0 1-.056-.055c0-.032.025-.057.056-.057h.223c.155 0 .28-.123.28-.277a.28.28 0 0 1 .277-.282.28.28 0 0 0 .282-.277Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.086 34.597c0-.16.129-.29.288-.29h1.175c.18 0 .325.143.325.322a.327.327 0 0 1-.345.327l-1.173-.074a.286.286 0 0 1-.27-.285Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.791 48.223c0-.154.125-.282.279-.282h1.23c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-1.23a.277.277 0 0 1-.279-.277Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 45.871c0-.154.123-.28.277-.28.155 0 .282.126.282.28v1.23a.277.277 0 0 1-.277.279.281.281 0 0 1-.282-.28v-1.229Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M216.873 35.816c0-.155.125-.282.279-.282h1.23c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-1.23a.277.277 0 0 1-.279-.277Z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.858 34.613c0-.166.132-.306.299-.306.191 0 .336.174.299.361l-.001.007a.309.309 0 0 1-.25.243.346.346 0 0 0-.26.3l-.061.613a.291.291 0 0 1-.29.264.295.295 0 0 1-.295-.294v-.539c0-.166.117-.308.279-.34l.033-.007a.308.308 0 0 0 .247-.302Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.375 32.24c0-.155.123-.28.277-.28.155 0 .282.125.282.28v1.229c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-1.23Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.238 28.608c0-.247.2-.45.447-.45h.224c.247 0 .447.196.447.443s-.2.45-.447.45h-.224a.444.444 0 0 1-.447-.443Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.24 22.738c0-.154.123-.279.278-.279.154 0 .281.125.281.28v1.229c0 .154-.123.28-.277.28a.281.281 0 0 1-.282-.28v-1.23Z",
    fill: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.375 18.047a.28.28 0 0 1 .279-.281h1.23c.154 0 .279.123.279.277a.281.281 0 0 1-.279.281h-1.23a.277.277 0 0 1-.279-.277Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M228.164 50.01c0-.154.125-.282.279-.282h1.118c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-1.118a.277.277 0 0 1-.279-.277Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.588 35.257c0-.154.123-.28.277-.28.154 0 .282.126.282.28v1.117c0 .155-.123.28-.278.28a.281.281 0 0 1-.281-.28v-1.117Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 32.24a.28.28 0 0 1 .28-.28h.112c.154 0 .279.123.279.277 0 .155.125.282.279.282h.107c.147 0 .258.133.229.277a.235.235 0 0 0 .229.282h.218c.031 0 .056.024.056.055 0 .03-.025.056-.056.056h-.947a.288.288 0 0 1-.281-.22 2.128 2.128 0 0 1-.023-.122c-.023-.157-.107-.328-.266-.328a.216.216 0 0 1-.216-.214v-.066Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.514 21.226a.058.058 0 0 1 .004.116l-1.29.092a.303.303 0 0 0-.274.23.308.308 0 0 1-.298.233h-.694a.294.294 0 0 1-.296-.293c0-.15.112-.28.262-.294.863-.085 1.717-.094 2.586-.084Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.934 17.38c0-.155.125-.282.279-.282h.615c.185 0 .335.147.335.332 0 .186-.15.338-.335.338h-1.397a.056.056 0 0 1-.056-.055c0-.031.025-.057.056-.057h.223c.155 0 .28-.122.28-.277Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M220.518 36.291a.245.245 0 0 1 .24-.197c.135 0 .247.11.247.245v.649c0 .185-.15.335-.335.335h-.056a.278.278 0 0 1-.28-.277.281.281 0 0 0-.279-.282h-.782a.056.056 0 0 1-.056-.055c0-.031.025-.056.056-.056h.888a.347.347 0 0 0 .341-.28l.016-.082Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.238 33.134c0-.03.025-.056.056-.057l.496-.006.31-.004a.888.888 0 0 1 .246.027c.094.036.123.152.124.253l.001.119a.28.28 0 0 0 .277.283c.153 0 .278.123.278.275a.283.283 0 0 1-.279.284h-.112a.277.277 0 0 1-.279-.278.28.28 0 0 0-.277-.281.28.28 0 0 1-.282-.278.281.281 0 0 0-.279-.28h-.223a.057.057 0 0 1-.057-.057Z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.414 47.663c0-.154.125-.281.28-.281h.111a.28.28 0 0 1 .002.559.281.281 0 0 0-.281.279v.056a.333.333 0 0 1-.333.335.338.338 0 0 1-.338-.335v-.056c0-.154.123-.28.278-.28a.28.28 0 0 0 .281-.277Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.666 46.766c0-.34.275-.615.615-.615h.279c.185 0 .335.15.335.336v.279c0 .03-.024.056-.055.056a.056.056 0 0 1-.056-.056v-.224a.278.278 0 0 0-.278-.279.281.281 0 0 0-.281.28v.558c0 .155-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.335Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M201.453 46.433c0-.154.125-.282.28-.282h.503c.185 0 .335.148.335.333 0 .185-.15.338-.335.338h-1.286a.055.055 0 0 1-.055-.056c0-.03.025-.056.055-.056h.224a.277.277 0 0 0 .279-.277Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.742 38.202c0-.175.142-.318.316-.318h.522c.155 0 .28.123.28.277 0 .154.125.282.279.282h.33a.06.06 0 0 1 .061.06v.079c0 .06-.087.072-.101.013a.053.053 0 0 0-.052-.04l-.183.003c-.787.008-.942.01-1.217-.055a.308.308 0 0 1-.235-.301Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.791 33.133c0-.154.123-.28.277-.28.155 0 .282.126.282.28v.894c0 .154-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.894Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.238 50.513c0-.123.1-.225.224-.225h1.341c.123 0 .223.099.223.222s-.1.225-.223.225h-1.341a.222.222 0 0 1-.224-.222Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.666 48.833c0-.185.15-.335.335-.335h2.906c.185 0 .335.15.335.335v.28c0 .03-.024.056-.055.056a.057.057 0 0 1-.057-.056v-.224a.28.28 0 0 0-.279-.28h-2.347a.277.277 0 0 0-.279.278.28.28 0 0 1-.277.282.281.281 0 0 1-.282-.28v-.056Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 21.01c0-.186.151-.338.336-.338h.056c.154 0 .279.123.279.277 0 .154.125.282.279.282h2.571c.031 0 .056.024.056.055s-.025.056-.056.056h-3.185a.334.334 0 0 1-.336-.332Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M196.201 46.488c0-.124.1-.225.224-.225h1.229c.123 0 .224.098.224.221a.226.226 0 0 1-.224.226h-1.229a.222.222 0 0 1-.224-.222Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M202.682 45.871c0-.154.123-.28.277-.28.154 0 .281.126.281.28v.559c0 .154.126.28.28.28h.223c.031 0 .056.024.056.055 0 .03-.025.056-.056.056h-.503a.558.558 0 0 1-.558-.559v-.39Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M208.494 28.213c0-.03.025-.056.056-.056.03 0 .056.025.056.056v2.068c0 .247.2.447.447.447h.168c.154 0 .279.123.279.277a.28.28 0 0 0 .279.281h1.23a.056.056 0 0 1 0 .112h-1.448a.345.345 0 0 1-.34-.277.35.35 0 0 0-.341-.282h-.017a.369.369 0 0 1-.369-.368v-2.258Z",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.24 21.79a.56.56 0 0 1 .559-.559h.503a.056.056 0 0 1 0 .112h-.224a.28.28 0 0 0-.279.28v.558c0 .155-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.39Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M208.49 20.728c0-.031.024-.056.055-.056s.057.025.057.056v.223c0 .155.125.28.279.28h.224c.03 0 .055.024.055.055s-.025.056-.055.056h-.224a.28.28 0 0 0-.279.28v.782a.056.056 0 1 1-.112 0v-.838a.223.223 0 0 0-.222-.224c-.123 0-.225.1-.225.224v.056a.28.28 0 0 1-.28.28h-2.682a.056.056 0 0 1-.056-.056c0-.031.025-.056.056-.056h2.571a.277.277 0 0 0 .279-.278.28.28 0 0 1 .277-.281.281.281 0 0 0 .282-.28v-.223Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M226.934 49.45a.28.28 0 0 1 .279-.281h.671c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-.671a.277.277 0 0 1-.279-.278Z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M202.014 44.09c0-.155.125-.282.279-.282h.671c.154 0 .279.123.279.277a.281.281 0 0 1-.279.281h-.671a.277.277 0 0 1-.279-.277Z",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.122 37.94a.059.059 0 0 1 .058-.056c.031 0 .058.024.059.056.08 1.943.14 3.868.002 5.811a.06.06 0 0 1-.06.056.06.06 0 0 1-.06-.056c-.129-1.945-.082-3.866.001-5.811Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.666 38.163c0-.154.123-.28.277-.28.155 0 .282.126.282.28v.67c0 .155-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.67Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.801 30.45c0-.155.123-.28.277-.28.154 0 .282.125.282.28v.67c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.67Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 28.664c0-.154.126-.281.28-.281h.67c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-.67a.278.278 0 0 1-.28-.278Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.068 21.624c0-.154.125-.281.28-.281h.67c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-.67a.278.278 0 0 1-.28-.278Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.601 20.465a.317.317 0 0 1 .315-.35.32.32 0 0 1 .321.319v.505a.291.291 0 0 1-.291.294.295.295 0 0 1-.294-.264l-.051-.504Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.086 17.377c0-.154.123-.28.277-.28.155 0 .282.126.282.28v.67c0 .155-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.67Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.801 44.087c0-.154.123-.28.277-.28.154 0 .282.126.282.28v.61a.278.278 0 0 1-.223.273.28.28 0 0 1-.336-.274v-.609Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.791 19.109a.281.281 0 0 1 .274-.227h.61c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-.61a.278.278 0 0 1-.274-.332Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.801 47.107c0-.155.125-.282.279-.282h.609c.133 0 .248.092.274.223a.28.28 0 0 1-.274.336h-.609a.277.277 0 0 1-.279-.277Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.444 31.091a.274.274 0 0 1 .272-.247c.119 0 .227.075.254.19.049.208.061.403.062.612a.315.315 0 0 1-.317.315.323.323 0 0 1-.322-.353l.051-.517Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.838 20.728c0-.031.024-.056.055-.056s.057.025.057.056v.223c0 .155.125.28.279.28h.671a.277.277 0 0 0 .279-.278.28.28 0 0 1 .559-.004c0 .154.125.282.279.282h.224c.031 0 .056.024.056.055s-.025.056-.056.056h-2.068a.335.335 0 0 1-.335-.335v-.28Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M220.45 50.01a.28.28 0 0 1 .278-.282c.154 0 .281.126.281.28v.056c0 .185-.15.335-.335.335h-2.515a.056.056 0 0 1 0-.112h2.012a.277.277 0 0 0 .279-.277Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M220.453 47.107c0-.155.125-.282.28-.282h.609a.28.28 0 0 1 0 .559h-.609a.278.278 0 0 1-.28-.277Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.299 38.833a.28.28 0 0 1 .279-.281h.609c.134 0 .248.092.274.223a.28.28 0 0 1-.274.336h-.609a.277.277 0 0 1-.279-.278Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.678 47.663a.28.28 0 0 1 .279-.281h.559c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-.559a.277.277 0 0 1-.279-.278Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.512 47.661c0-.154.123-.28.277-.28.154 0 .282.126.282.28v.559c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.559Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M193.74 47.663c0-.154.125-.281.28-.281h.558c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-.558a.278.278 0 0 1-.28-.278Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M199.107 45.873c0-.154.126-.281.28-.281h.559c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-.559a.278.278 0 0 1-.28-.278Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M197.877 45.873a.28.28 0 0 1 .279-.281h.559c.154 0 .28.123.28.277a.282.282 0 0 1-.28.282h-.559a.277.277 0 0 1-.279-.278Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M208.605 44.755c0-.154.123-.28.278-.28.154 0 .281.126.281.28v.559c0 .154-.123.28-.277.28a.282.282 0 0 1-.282-.28v-.559Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.01 44.087c0-.154.123-.28.277-.28.154 0 .282.126.282.28v.559c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.559Zm-10.061-.56c0-.154.123-.279.278-.279.154 0 .281.125.281.28v.558c0 .154-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.559Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.238 43.53c0-.155.125-.282.28-.282h.558c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-.558a.278.278 0 0 1-.28-.278Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M208.049 41.183c0-.154.125-.282.279-.282h.559c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-.559a.277.277 0 0 1-.279-.277Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M206.818 39.39c0-.154.123-.279.278-.279.154 0 .281.125.281.28v.559a.277.277 0 0 1-.277.279.282.282 0 0 1-.282-.28v-.558Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.086 35.259c0-.154.125-.282.279-.282h.559c.154 0 .28.123.28.278a.282.282 0 0 1-.28.281h-.559a.277.277 0 0 1-.279-.277Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.666 34.697c0-.154.123-.279.277-.279.155 0 .282.125.282.28v.558c0 .154-.123.28-.277.28a.281.281 0 0 1-.282-.28v-.559Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 34.029c0-.155.126-.282.28-.282h.559c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-.559a.278.278 0 0 1-.28-.277Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.588 29.333c0-.154.123-.28.277-.28.154 0 .282.126.282.28v.559c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.559Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.475 29.335a.28.28 0 0 1 .279-.281h.559c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-.559a.277.277 0 0 1-.279-.278Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M216.316 25.756c0-.154.123-.28.278-.28.154 0 .281.126.281.28v.559c0 .154-.123.28-.277.28a.282.282 0 0 1-.282-.28v-.559Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.566 23.406c0-.154.123-.279.278-.279a.28.28 0 0 1 .281.28v.558c0 .154-.123.28-.277.28a.282.282 0 0 1-.282-.28v-.559Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.566 21.622c0-.154.123-.28.278-.28.154 0 .281.126.281.28v.559c0 .154-.123.28-.277.28a.282.282 0 0 1-.282-.28v-.559Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 20.397c0-.155.125-.282.28-.282H210c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-.558a.278.278 0 0 1-.28-.277Z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.299 19.832c0-.154.123-.28.277-.28.154 0 .282.126.282.28v.559c0 .154-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.559Zm7.711-1.227c0-.155.123-.28.277-.28.154 0 .282.125.282.28v.558c0 .155-.123.28-.278.28a.281.281 0 0 1-.281-.28v-.558Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 16.26c0-.154.126-.282.28-.282h.559c.154 0 .279.124.279.278a.281.281 0 0 1-.279.281h-.559a.278.278 0 0 1-.28-.277Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.742 15.7c0-.154.125-.281.28-.281h.558c.155 0 .28.123.28.277a.281.281 0 0 1-.28.282h-.558a.278.278 0 0 1-.28-.278Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M227 49.955a.281.281 0 0 1 .274-.227h.498c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-.498a.278.278 0 0 1-.274-.332Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.186 45.317c0-.155.125-.282.279-.282h.497c.177 0 .309.16.275.332a.282.282 0 0 1-.275.227h-.497a.277.277 0 0 1-.279-.277Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M206.145 39.39c0-.154.123-.279.277-.279.154 0 .281.125.281.28v.497a.278.278 0 0 1-.332.275.282.282 0 0 1-.226-.275v-.497Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.299 46.43a.28.28 0 0 1 .559-.002c0 .155.125.282.279.282h1.453a.056.056 0 0 1 0 .112h-1.956a.335.335 0 0 1-.335-.335v-.056Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.299 50.513c0-.123.1-.225.223-.225h.783c.123 0 .223.099.223.222s-.1.225-.223.225h-.783a.222.222 0 0 1-.223-.222Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.195 31.627c0-.185.15-.338.336-.338h.163c.163 0 .303.116.33.278a.337.337 0 0 1-.33.393h-.163a.333.333 0 0 1-.336-.333Z",
    fill: "#767675"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M216.2 14.804c0-.03.024-.056.055-.056s.057.025.057.056v.223c0 .155.125.28.279.28h1.341c.031 0 .056.024.056.055s-.025.057-.056.057h-1.336a.234.234 0 0 0-.229.279l.032.159a.1.1 0 0 1-.098.12.101.101 0 0 1-.101-.1v-.179a.28.28 0 0 0-.28-.28h-1.341a.056.056 0 0 1-.056-.055c0-.03.025-.056.056-.056h1.341a.28.28 0 0 0 .28-.28v-.223Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M229.951 50.513c0-.123.1-.225.224-.225h.67c.124 0 .224.099.224.222s-.1.225-.224.225h-.67a.222.222 0 0 1-.224-.222Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.24 34.53c0-.123.099-.223.222-.223.124 0 .225.1.225.223v.67a.222.222 0 0 1-.222.224.225.225 0 0 1-.225-.223v-.67Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.645 46.881c0-.03.024-.056.055-.056s.056.025.056.056v.673c0 .229-.152.45-.379.47a.36.36 0 0 1-.094-.002c-.129-.022-.197-.162-.197-.293v-.066c0-.154.123-.279.277-.279a.281.281 0 0 0 .282-.28v-.223Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M206.484 28.548a.39.39 0 0 1 .392-.39h.391a.11.11 0 0 1 .111.11c0 .062-.05.113-.111.113h-.168a.28.28 0 0 0-.279.28v.893a.056.056 0 1 1-.112 0v-.503a.111.111 0 0 0-.111-.111.113.113 0 0 1-.113-.112v-.28Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.068 48.894c0-.154.125-.282.28-.282h.056c.185 0 .335.15.335.336v.726c0 .03-.025.056-.056.056a.057.057 0 0 1-.056-.056v-.224a.278.278 0 0 0-.277-.279.28.28 0 0 1-.282-.277Z",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.068 20.45c0-.185.15-.335.336-.335h.056a.28.28 0 0 1 .002.559.281.281 0 0 0-.282.28v.223c0 .03-.024.056-.055.056a.057.057 0 0 1-.057-.056v-.726Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.397 42.644a.15.15 0 0 1 .161-.033l.3.12c.101.04.168.137.168.246 0 .147-.12.268-.267.268h-.073a.331.331 0 0 1-.334-.331l.002-.168c0-.039.016-.075.043-.102Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.551 37.94c0-.031.024-.056.055-.056s.056.025.056.056v.894c0 .154-.123.28-.277.28a.281.281 0 0 1-.281-.28v-.056c0-.124.098-.224.221-.224.124 0 .226-.1.226-.223v-.391Z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.566 22.764c0-.168.136-.305.303-.305h.06c.17 0 .308.135.308.305a.31.31 0 0 1-.358.306l-.06-.01a.3.3 0 0 1-.253-.296Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 50.568a.17.17 0 0 1 .168-.169h.782c.093 0 .168.074.168.167a.169.169 0 0 1-.168.169h-.782a.167.167 0 0 1-.168-.167Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.068 37.603c0-.154.125-.282.28-.282h.112c.154 0 .279.123.279.278a.281.281 0 0 1-.279.281h-.112a.278.278 0 0 1-.28-.277Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.588 31.009c0-.154.123-.28.277-.28.154 0 .282.126.282.28v.112a.278.278 0 0 1-.278.279.28.28 0 0 1-.281-.28v-.111Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 30.451c0-.154.126-.281.28-.281h.112c.154 0 .279.123.279.277a.281.281 0 0 1-.279.282h-.112a.278.278 0 0 1-.28-.278Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 29.78c0-.092.074-.167.166-.167.093 0 .169.075.169.168v.782a.166.166 0 0 1-.166.168.169.169 0 0 1-.169-.168v-.782Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.856 34.609c0-.167.136-.302.302-.302h.008c.187 0 .327.17.29.353l-.025.126a.114.114 0 0 1-.096.09l-.477.07c-.042.005-.06-.051-.022-.07a.038.038 0 0 0 .02-.033v-.234Z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M216.316 48.839c0-.176.147-.312.319-.277.131.026.24.144.24.277v.05c0 .154-.123.28-.277.28a.282.282 0 0 1-.282-.28v-.05Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M220.453 50.01a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Zm-7.711 0a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.949 50.01a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 49.45a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.666 48.894a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Zm-4.143-1.231a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#9D9D9D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M215.086 47.107a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.299 45.873a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Zm7.154-.556a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.238 45.317a.28.28 0 1 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 41.74a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M207.375 40.512a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M217.436 38.722a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 38.722a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.742 38.165a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M217.992 38.165a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M219.217 37.603a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.393 37.603a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.949 37.046a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.725 36.375a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 36.375a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.186 36.375a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M219.779 35.816a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.967 35.816a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.299 35.816a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M212.742 35.816a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.725 35.816a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M208.605 35.816a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.855 35.259a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.725 35.259a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 35.259a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 34.588a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 34.588a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.475 34.029a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.588 33.469a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.025 32.242a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.357 32.242a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M203.801 29.895a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.588 29.335a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Zm-1.787 0a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.588 28.664a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Zm-1.787 0a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M218.104 26.318a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M222.24 23.97a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M221.01 22.74a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.967 20.953a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M208.605 20.953a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.475 20.953a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.512 20.397a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 20.397a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M220.453 19.834a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.512 19.834a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.949 19.834a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Zm1.793-.671a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M204.475 19.275a.28.28 0 1 1 .558-.004.28.28 0 1 1-.558.004Z",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.162 18.607a.28.28 0 0 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M206.818 18.047a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Zm10.055-1.23a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Zm-1.787 0a.28.28 0 0 1 .559-.004.28.28 0 1 1-.559.004Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 16.817a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M213.855 16.26a.28.28 0 1 1 .559-.004.28.28 0 0 1-.559.004Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.025 30.479c0-.159.146-.28.301-.249l.061.012a.244.244 0 0 1 .197.24c0 .135-.11.247-.245.247h-.062a.25.25 0 0 1-.252-.25Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 21.652c0-.159.146-.28.302-.249l.06.012a.243.243 0 0 1 .197.24c0 .135-.11.247-.245.247h-.062a.25.25 0 0 1-.252-.25Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.523 35.23a.25.25 0 0 1 .25-.252c.159 0 .28.145.249.3l-.012.06a.244.244 0 0 1-.239.198.247.247 0 0 1-.248-.245v-.062Z",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M211.512 44.7c0-.123.1-.224.223-.224h.112c.123 0 .224.098.224.221a.226.226 0 0 1-.224.226h-.112a.222.222 0 0 1-.223-.222Z",
    fill: "#020202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.836 42.241c0-.123.098-.223.222-.223.123 0 .225.1.225.223v.112a.222.222 0 0 1-.222.223.225.225 0 0 1-.225-.223v-.112Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M209.725 36.99c0-.124.1-.225.223-.225h.112c.123 0 .223.098.223.221 0 .124-.1.226-.223.226h-.112a.222.222 0 0 1-.223-.222Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.949 36.43c0-.123.1-.225.224-.225h.111c.124 0 .224.099.224.222s-.1.225-.224.225h-.111a.222.222 0 0 1-.224-.222Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.393 36.317c0-.123.098-.223.221-.223.124 0 .226.1.226.223v.112a.222.222 0 0 1-.222.224.224.224 0 0 1-.225-.224v-.112Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.393 35.758c0-.124.098-.224.221-.224.124 0 .226.1.226.224v.111a.223.223 0 0 1-.222.224.224.224 0 0 1-.225-.224v-.111Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M205.025 32.856c0-.123.1-.225.224-.225h.112c.123 0 .223.098.223.222 0 .123-.1.225-.223.225h-.112a.222.222 0 0 1-.224-.222Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M214.195 29.78c0-.03.025-.055.056-.055s.056.025.056.055v1.062a.11.11 0 0 0 .111.112c.062 0 .113.05.113.112v.056a.167.167 0 0 1-.167.167.17.17 0 0 1-.169-.167V29.78Z",
    fill: "#180301"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M210.95 29.78c0-.03.025-.055.056-.055.03 0 .056.025.056.055v1.342a.167.167 0 0 1-.167.167.168.168 0 0 1-.168-.167v-.056a.11.11 0 0 1 .11-.112c.062 0 .113-.05.113-.112v-1.061Z",
    fill: "#190302"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "logoThatMoves"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Group 1000004041"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Ellipse 3",
    cx: 549.02,
    cy: 409.42,
    r: 26.458,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    className: "Calque",
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Group 1000004041"
  }, /*#__PURE__*/React.createElement("g", {
    className: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Vector",
    d: "M549.028 414.833c-1.615 0-1.884.09-2.332-.359-.449-.449-.36-.718-.36-2.243 0-1.615-.09-1.884.36-2.423.448-.448.717-.359 2.332-.359 1.614 0 1.884-.09 2.332.359.449.539.359.808.359 2.423 0 1.525.09 1.794-.359 2.243-.448.448-.718.359-2.332.359Zm2.691-13.457v5.383c0 1.615-.09 1.884.359 2.332.539.449.718.36 2.333.36 1.614 0 1.884.09 2.332-.36.448-.448.359-.717.359-2.332v-5.383c0-1.345 1.346-2.691 2.692-2.691s2.691 1.345 2.691 2.691v5.383c0 1.346-1.345 2.692-2.691 2.692-1.615 0-1.884-.09-2.333.359-.448.448-.359.717-.359 2.332 0 1.345-1.345 2.692-2.691 2.692-1.615 0-1.884-.09-2.333.359-.448.448-.359.717-.359 2.332 0 1.345-1.345 2.691-2.691 2.691-1.346 0-2.692-1.345-2.692-2.691 0-1.615.09-1.884-.359-2.332-.448-.449-.717-.359-2.332-.359-1.346 0-2.692-1.346-2.692-2.692 0-1.615.09-1.884-.359-2.332-.448-.449-.717-.359-2.332-.359-1.345 0-2.691-1.346-2.691-2.692v-5.383c0-1.345 1.345-2.691 2.691-2.691 1.346 0 2.691 1.345 2.691 2.691v5.383c0 1.615-.09 1.884.36 2.332.449.449.717.36 2.332.36 1.615 0 1.794.09 2.332-.36.449-.448.359-.717.359-2.332v-5.383c0-1.614.09-1.884-.359-2.332-.448-.448-.717-.359-2.332-.359-1.346 0-2.692-1.346-2.692-2.692 0-1.614.09-1.883-.359-2.332-.448-.448-.717-.359-2.332-.359-1.615 0-1.884-.09-2.332.359-.449.449-.359.718-.359 2.332 0 1.346-1.346 2.692-2.692 2.692-1.615 0-1.884-.09-2.332.359-.449.448-.359.718-.359 2.332v5.383c0 1.615-.09 1.884.359 2.332.448.449.717.36 2.332.36 1.345 0 2.692 1.345 2.692 2.691 0 1.615-.09 1.884.359 2.332.448.449.717.36 2.332.36 1.345 0 2.691 1.345 2.691 2.691 0 1.615-.09 1.884.36 2.332.448.449.717.359 2.332.359 1.345 0 2.691 1.346 2.691 2.692 0 1.615-.09 1.884.36 2.332.448.449.717.359 2.332.359 1.614 0 1.884.09 2.332-.359.449-.448.359-.717.359-2.332 0-1.345 1.346-2.692 2.692-2.692 1.614 0 1.884.09 2.332-.359.448-.448.359-.717.359-2.332 0-1.345 1.346-2.691 2.692-2.691 1.614 0 1.883.09 2.332-.36.448-.449.359-.717.359-2.332 0-1.345 1.345-2.691 2.692-2.691 1.614 0 1.883.09 2.332-.36.448-.448.359-.717.359-2.332v-5.383c0-1.614.09-1.884-.359-2.332-.449-.448-.718-.359-2.332-.359-1.346 0-2.692-1.346-2.692-2.692 0-1.614.09-1.883-.359-2.332-.449-.448-.718-.359-2.332-.359-1.615 0-1.884-.09-2.333.359-.448.449-.359.718-.359 2.332 0 1.346-1.345 2.692-2.691 2.692-1.615 0-1.884-.09-2.333.359-.448.448-.359.718-.359 2.332Zm-2.691 29.604c-1.346 0-2.692-1.345-2.692-2.691 0-1.615.09-1.884-.359-2.332-.448-.449-.717-.36-2.332-.36-1.346 0-2.692-1.345-2.692-2.691 0-1.615.09-1.884-.359-2.332-.448-.449-.717-.36-2.332-.36-1.345 0-2.691-1.345-2.691-2.691 0-1.615.089-1.884-.36-2.332-.448-.449-.717-.359-2.332-.359-1.345 0-2.691-1.346-2.691-2.692 0-1.614.09-1.884-.36-2.332-.448-.449-.717-.359-2.332-.359-1.345 0-2.691-1.346-2.691-2.692v-5.383c0-1.345 1.345-2.691 2.691-2.691 1.615 0 1.884.09 2.332-.359.449-.449.36-.718.36-2.333 0-1.345 1.345-2.691 2.691-2.691 1.615 0 1.884.09 2.332-.359.449-.449.36-.718.36-2.333 0-1.345 1.345-2.691 2.691-2.691 1.346 0 2.691 1.345 2.691 2.691 0 1.615-.09 1.884.36 2.333.448.448.717.359 2.332.359 1.345 0 2.691 1.345 2.691 2.691 0 1.615-.09 1.884.36 2.333.449.448.717.359 2.332.359 1.614 0 1.884.09 2.332-.359.449-.449.359-.718.359-2.333 0-1.345 1.346-2.691 2.692-2.691 1.614 0 1.884.09 2.332-.359.448-.449.359-.718.359-2.333 0-1.345 1.346-2.691 2.692-2.691s2.691 1.345 2.691 2.691c0 1.615-.09 1.884.359 2.333.449.448.718.359 2.333.359 1.345 0 2.691 1.345 2.691 2.691 0 1.615-.09 1.884.359 2.333.449.448.718.359 2.332.359 1.346 0 2.692 1.345 2.692 2.691v5.383c0 1.346-1.345 2.692-2.692 2.692-1.614 0-1.883-.09-2.332.359-.448.448-.359.718-.359 2.332 0 1.346-1.345 2.692-2.691 2.692-1.615 0-1.884-.09-2.333.359-.448.448-.359.717-.359 2.332 0 1.345-1.345 2.691-2.691 2.691-1.615 0-1.884-.089-2.333.36-.448.448-.359.717-.359 2.332 0 1.345-1.345 2.691-2.691 2.691-1.615 0-1.884-.09-2.333.36-.448.448-.359.717-.359 2.332 0 1.345-1.345 2.691-2.691 2.691Z",
    fill: "#000"
  })))))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "logoThatMoves",
    y: 276,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "url(#ba)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "az",
    className: "a",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#K"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ay",
    className: "b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#L"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "at",
    className: "g",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.005)",
    href: "#M"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ar",
    className: "i",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#N"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aq",
    className: "j",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#N"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ap",
    className: "k",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#O"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ao",
    className: "l",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#P"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "an",
    className: "m",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#Q"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "am",
    className: "n",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#R"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "al",
    className: "o",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.00268)",
    href: "#S"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ak",
    className: "p",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.00195)",
    href: "#T"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "aj",
    className: "q",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#U"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ai",
    className: "r",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#V"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bg",
    className: "D",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.01)",
    href: "#W"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bf",
    className: "E",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#X"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "be",
    className: "F",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#Y"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bd",
    className: "G",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bc",
    className: "H",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#aa"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ba",
    className: "J",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.0025)",
    href: "#ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    className: "f",
    x1: 294.15,
    x2: 293.62,
    y1: 136.44,
    y2: 146.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    className: "u",
    x1: 152.17,
    x2: 152.17,
    y1: 530.52,
    y2: 541.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E3F2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F7891",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    className: "v",
    x1: 152.16,
    x2: 152.16,
    y1: 516.62,
    y2: 524.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46D1BD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24566B",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    className: "w",
    x1: 152.11,
    x2: 152.11,
    y1: 502.62,
    y2: 510.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8FB6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08181D",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    className: "x",
    x1: 163.37,
    x2: 163.37,
    y1: 523.58,
    y2: 530.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C4D1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#245A6B",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    className: "y",
    x1: 140.96,
    x2: 140.96,
    y1: 523.58,
    y2: 530.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C4D1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#245A6B",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    className: "z",
    x1: 142.01,
    x2: 142.01,
    y1: 509.43,
    y2: 516.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35ABD9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102C36",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    className: "A",
    x1: 162.35,
    x2: 162.35,
    y1: 509.43,
    y2: 516.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35ABD9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102C36",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    className: "B",
    x1: 170.01,
    x2: 170.01,
    y1: 518.4,
    y2: 523.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46D1BD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24566B",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    className: "C",
    x1: 134.29,
    x2: 134.29,
    y1: 518.4,
    y2: 523.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46D1BD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24566B",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax",
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.94 176.9h52.916v52.916h-52.916z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av",
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m272.96 136h29.715v41.906h-29.715z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah",
    className: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.084 239.205H600V299h-52.916z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb",
    className: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m524.81 387.92h48.444v43.061h-48.444z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcosystem1);
export default __webpack_public_path__ + "static/media/ecosystem1.d83eccede32e6bf3fb037f403f681ac4.svg";
export { ForwardRef as ReactComponent };